import React, {FC, useEffect, useRef, useState} from 'react'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import {
  config,
  fetchData,
  fetchFormData,
  getTranslatedValue,
  hasSpecialCharacters,
  isOnlyNumber,
  toasterrormsg,
  toastsuccessmsg,
} from '../../../reusable'
import {PageTitle} from '../../../_metronic/layout/core'
import JoditEditor from 'jodit-react'
import {Modal} from 'react-bootstrap'
import Select from 'react-select'
import {MixedWidget24} from '../../../_metronic/partials/widgets'
import Swal from 'sweetalert2'
import {AddTourPackageHeader} from './AddTourPackageHeader'
import clsx from 'clsx'
import {useMediaReorder, ReorderButton, UploadedImageGrid, NewImageGrid} from '../mediaReorder'
import AutoComplete3 from '../AddressAutoComplete3'
import GoogleMapComponent2 from '../GoogleMapComponent2'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import PriceInput from '../PriceInput'
import imageCompression from 'browser-image-compression'
import moment from 'moment'
import Flatpickr from 'react-flatpickr'
import 'flatpickr/dist/flatpickr.min.css'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'
import {Tr} from '../../../_metronic/i18n/Tr'
import StepErrorAlert from '../StepErrorAlert'
import {useLang} from '../../../_metronic/i18n/Metronici18n'

const ViewTours: FC = () => {
  const t = Tr()
  const lang = useLang()
  const navigate = useNavigate()
  const categoryId = sessionStorage.getItem('categoryId')
  useEffect(() => {
    if (categoryId != '5') {
      navigate('../dashboard/')
    }
  }, [categoryId])
  const editorRef = useRef(null)
  const inputfileRef = useRef(null)
  const location = useLocation()
  const [loading, setLoading] = useState(false)
  const editTourpackageId = (location.state as any)?.tourpackageId || ''

  const primaryLanguage = localStorage.getItem('primaryLanguage')
  // -------- state start ------------
  const [editToursId, setEditToursId] = useState('')
  const [tab, setTab] = useState('BasicInfo') // BasicInfo, TourDetails, FacilityAndServices, PricingAndAvailability, TourPhotos
  const [priceTab, setPriceTab] = useState('RegularPrice') // RegularPrice, SpecialPrice, Availability
  const [priceStepError, setPriceStepError] = useState('')
  useEffect(() => {
    setPriceStepError('')
  }, [priceTab])
  const [disable, setDisable] = useState(false)
  const [tourPackageDetails, setTourPackageDetails] = useState([])
  const [tourPackageDetail, setTourPackageDetail] = useState([])
  const [primLanguage, setPrimLanguage] = useState('')
  const [tourNameEN, setTourNameEN] = useState('')
  const [tourNameRU, setTourNameRU] = useState('')
  const [tourNameUZ, setTourNameUZ] = useState('')
  const [maxPeople, setMaxPeople] = useState('')
  const [baseCharge, setBaseCharge] = useState('')
  const [inputImage, setInputImage] = useState([]) as any
  const [uploadedImage, setUploadedImage] = useState([]) as any;
  const reorder = useMediaReorder({
      type: 'tours',
      inputImage,
      setInputImage,
      uploadedImage,
      setUploadedImage,
  });
  // tour package list departureState start
  const [tourTypeList, setTourTypeList] = useState([])
  const [tourTypeSelectedOptions, setTourTypeSelectedOptions] = useState<any>([])
  const tourType = tourTypeSelectedOptions
    ? tourTypeSelectedOptions.map((option: any) => option.value).join(',')
    : ''
  // tour package list departureState end
  const [departureCountry, setDepartureCountry] = useState('')
  const [departureState, setDepartureState] = useState('')
  const [departureCity, setDepartureCity] = useState('')
  const [departureAddress, setDepartureAddress] = useState('')
  const [departureLongitude, setDepartureLongitude] = useState('')
  const [departureLatitude, setDepartureLatitude] = useState('')
  // region list state start
  const [regionList, setRegionList] = useState([])
  const [regionSelectedOptions, setRegionSelectedOptions] = useState<any>([])
  // region list state end
  const [locationObj, setLocationObj] = useState(null) as any
  useEffect(() => {
    if (locationObj) {
      setDepartureCountry(locationObj.country)
      setDepartureState(locationObj.state)
      setDepartureCity(locationObj.city)
      setDepartureAddress(locationObj.location)
      setDepartureLatitude(locationObj.latitude)
      setDepartureLongitude(locationObj.longitude)
    }
  }, [locationObj])
  const [highlightEN, setHighlightEN] = useState('')
  const [highlightRU, setHighlightRU] = useState('')
  const [highlightUZ, setHighlightUZ] = useState('')
  const [itinararyEN, setItinararyEN] = useState('')
  const [itinararyRU, setItinararyRU] = useState('')
  const [itinararyUZ, setItinararyUZ] = useState('')
  const [whatToExpectEN, setWhatToExpectEN] = useState('')
  const [whatToExpectRU, setWhatToExpectRU] = useState('')
  const [whatToExpectUZ, setWhatToExpectUZ] = useState('')
  const [meetingPointEN, setMeetingPointEN] = useState('')
  const [meetingPointRU, setMeetingPointRU] = useState('')
  const [meetingPointUZ, setMeetingPointUZ] = useState('')
  const [activityEssentialEN, setActivityEssentialEN] = useState('')
  const [activityEssentialRU, setActivityEssentialRU] = useState('')
  const [activityEssentialUZ, setActivityEssentialUZ] = useState('')
  // service list state start
  const [serviceList, setServiceList] = useState([])
  const [serviceSelectedOptions, setServiceSelectedOptions] = useState<any>([])
  const serviceId = serviceSelectedOptions
    ? serviceSelectedOptions.map((option: any) => option.value).join(',')
    : ''
  // service list state end
  // service language list state start
  const [serviceLanguageList, setServiceLanguageList] = useState([])
  const [serviceLanguageSelectedOptions, setServiceLanguageSelectedOptions] = useState<any>([])
  var serviceLanguage = serviceLanguageSelectedOptions
    ? serviceLanguageSelectedOptions.map((option: any) => option.value).join(',')
    : ''
  // service language list state end
  // whats included & not included list state start
  const [whatsIncludedList, setWhatsIncludedList] = useState([])
  const [whatsIncludedSelectedOptions, setWhatsIncludedSelectedOptions] = useState<any>([])
  var whatsIncluded = whatsIncludedSelectedOptions
    ? whatsIncludedSelectedOptions.map((option: any) => option.value).join(',')
    : ''

  const [whatsNotIncludedSelectedOptions, setWhatsNotIncludedSelectedOptions] = useState<any>([])
  var whatsNotIncluded = whatsNotIncludedSelectedOptions
    ? whatsNotIncludedSelectedOptions.map((option: any) => option.value).join(',')
    : ''
  const handleIncludedChange = (selectedOptions: any) => {
    setWhatsIncludedSelectedOptions(selectedOptions)
  }

  const handleNotIncludedChange = (selectedOptions: any) => {
    setWhatsNotIncludedSelectedOptions(selectedOptions)
  }

  const getFilteredOptions = (excludedOptions: any) => {
    return whatsIncludedList.filter(
      (option: any) =>
        !excludedOptions.some((excludedOption: any) => excludedOption.value === option.value)
    )
  }
  // whats included & not included list state end

  const [durationDay, setDurationDay] = useState('')
  const [durationHour, setDurationHour] = useState('')
  const [fromAvailableDate, setFromAvailableDate] = useState('')
  const [toAvailableDate, setToAvailableDate] = useState('')
  const [isYear, setIsYear] = useState(false)

  const handleIsYear = (e: any) => {
    setIsYear(e.target.checked) // Toggle the checked state
  }

  const [activityHighlightsAccordionShow, setActivityHighlightsAccordionShow] = useState(false)
  const [itinararyAccordionShow, setItinararyAccordionShow] = useState(false)
  const [whatToexpectAccordionShow, setWhatToexpectAccordionShow] = useState(false)
  const [meetingPointAccordionShow, setMeetingPointAccordionShow] = useState(false)
  const [activityEssentialAccordionShow, setActivityEssentialAccordionShow] = useState(false)

  // handle modal show & hide
  const [show, setShow] = useState(false)
  const handleClose = () => {
    setShow(false)
    setEditToursId('')
    cleanStates()
  }
  const handleShow = () => setShow(true)

  const [offset, setoffset] = useState(0)
  const [limit, setlimit] = useState(9)
  const [page, setpage] = useState(1)
  const [totalPage, setTotalPage] = useState(1)
  const [from, setfrom] = useState(1)
  const [to, setTo] = useState(1)
  const [displayTourList, setDisplayTourList] = useState([])
  const [pageNumbersList, setPageNumberList] = useState([1])
  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')
  const [en_title, setEn_title] = useState('')
  const [ru_title, setRu_title] = useState('')
  const [uz_title, setUz_title] = useState('')
  const [mondayPrice, setMondayPrice] = useState('0')
  const [tuesdayPrice, setTuesdayPrice] = useState('0')
  const [wednesdayPrice, setWednesdayPrice] = useState('0')
  const [thursdayPrice, setThursdayPrice] = useState('0')
  const [fridayPrice, setFridayPrice] = useState('0')
  const [saturdayPrice, setSaturdayPrice] = useState('0')
  const [sundayPrice, setSundayPrice] = useState('0')
  const [specialPrice, setSpecialPrice] = useState([]) as any
  const [meetingPoints, setMeetingPoints] = useState([{en_name: '', ru_name: '', uz_name: ''}])

  const [editIndex, setEditIndex] = useState(-1)
  const [error, setError] = useState([
    {
      departureAddress: '',
      tourNameEN: '',
      tourNameRU: '',
      tourNameUZ: '',
      tourType: '',
      highlightEN: '',
      highlightRU: '',
      highlightUZ: '',
      itinararyEN: '',
      itinararyRU: '',
      itinararyUZ: '',
      whatToExpectEN: '',
      whatToExpectRU: '',
      whatToExpectUZ: '',
      meetingPointEN: '',
      meetingPointRU: '',
      meetingPointUZ: '',
      activityEssentialEN: '',
      activityEssentialRU: '',
      activityEssentialUZ: '',
      regionId: '',
      service: '',
      serviceLanguage: '',
      maxPeople: '',
      baseCharge: '',
      inputImage: '',
      durationDay: '',
      durationHour: '',
      fromAvailableDate: '',
      toAvailableDate: '',
      whatsIncluded: '',
    },
  ])
  const [validationErrors, setValidationErrors] = useState([
    {
      en_title: '',
      ru_title: '',
      uz_title: '',
      fromDate: '',
      toDate: '',
      mondayPrice: '',
      tuesdayPrice: '',
      wednesdayPrice: '',
      thursdayPrice: '',
      fridayPrice: '',
      saturdayPrice: '',
      sundayPrice: '',
    },
  ])
  const [errors, setErrors] = useState({
    en_name: '',
    ru_name: '',
    uz_name: '',
  }) as any
  // ----------- state end ------------

  // ----------------------- functions ----------------------------
  // page number generater
  function generatePageNumbers(currentPage: any, totalPages: any, maxPagesToShow: any) {
    const halfMaxPages = Math.floor(maxPagesToShow / 2)
    let startPage = Math.max(1, currentPage - halfMaxPages)
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1)

    // Adjust startPage and endPage if the total pages to show is less than maxPagesToShow
    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1)
    }

    // Generate the list of page numbers
    const pageNumbers = []
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i)
    }

    return pageNumbers
  }
  // on page change function
  const onpagecahnge = (pageId: any) => {
    if (pageId != page && pageId != 0 && pageId <= totalPage) {
      var tmp = (pageId - 1) * limit
      setpage(pageId)
      setoffset(tmp)
      setfrom(tmp + 1)
      // setto
      var mod = tourPackageDetail.length % limit
      var tolimi: any = limit
      if (mod > 0) {
        if (mod <= limit) {
          tolimi = pageId * limit
        } else {
          tolimi = pageId * limit + limit
        }
      } else {
        tolimi = pageId * limit
      }
      setTo(tolimi)
      var tmpdata: any = tourPackageDetail.slice(tmp, tolimi)
      setDisplayTourList(tmpdata)
    }
  }

  const handleAddMettingPoints = () => {
    setMeetingPoints([...meetingPoints, {en_name: '', ru_name: '', uz_name: ''}])
  }

  const handleRemoveMettingPoints = (index: any) => {
    if (meetingPoints.length === 1) return // Prevent removing the last row
    const updatedPolicies = meetingPoints.filter((_, i) => i !== index)
    setMeetingPoints(updatedPolicies)
    // Clear errors for removed policy
    const updatedErrors = {...errors} as any
    delete updatedErrors[index]
    setErrors(updatedErrors)
  }

  const handleMettingPointsChange = (index: any, field: any, value: any) => {
    const updatedPolicies = [...meetingPoints] as any
    updatedPolicies[index][field] = value
    setMeetingPoints(updatedPolicies)
    // Clear error when user starts typing
    const updatedErrors = {...errors} as any
    delete updatedErrors[index]
    setErrors(updatedErrors)
  }
  // remove validation function
  const removeError = (err: any) => {
    var tmp = [...error] as any
    tmp[0][err] = ''
    setError(tmp)
  }
  const clearValidationError = (err: any) => {
    var tmp = [...validationErrors] as any
    tmp[0][err] = ''
    setValidationErrors(tmp)
  }

  const formatDate = (date: any) => {
    return moment(date).format('DD-MM-YYYY h:mm A')
  }

  const validateSpecialPrice = () => {
    let isValid = true
    const errorTmp = [...validationErrors]

    if (primaryLanguage === 'English') {
      if (!en_title.trim()) {
        errorTmp[0].en_title = t('Title Is Required')
        isValid = false
      } else if (!hasSpecialCharacters(en_title.trim())) {
        errorTmp[0].en_title = t('Special Characters Are Not Allowed')
        isValid = false
      }
    } else if (primaryLanguage === 'Russian') {
      if (!ru_title.trim()) {
        errorTmp[0].ru_title = t('Title Is Required')
        isValid = false
      } else if (!hasSpecialCharacters(ru_title.trim())) {
        errorTmp[0].ru_title = t('Special Characters Are Not Allowed')
        isValid = false
      }
    } else if (primaryLanguage === 'Uzbek') {
      if (!uz_title.trim()) {
        errorTmp[0].uz_title = t('Title Is Required')
        isValid = false
      } else if (!hasSpecialCharacters(uz_title.trim())) {
        errorTmp[0].uz_title = t('Special Characters Are Not Allowed')
        isValid = false
      }
    }

    if (!fromDate && fromDate != '0') {
      errorTmp[0].fromDate = t('Start Date Is Required.')
      isValid = false
    }
    if (!toDate && toDate != '0') {
      errorTmp[0].toDate = t('End Date Is Required.')
      isValid = false
    }
    if (toDate != '' && fromDate != '' && toDate < fromDate) {
      errorTmp[0].toDate = t("End Date Can't Be Smaller Than Start Date.")
      isValid = false
    }
    if (moment(fromDate).isBefore(moment().startOf('day'))) {
      errorTmp[0].fromDate = t("Start Date Can't Be In The Past.")
      isValid = false
    }
    if (!mondayPrice && mondayPrice != '0') {
      errorTmp[0].mondayPrice = t('Price Is Required.')
      isValid = false
    }
    if (!tuesdayPrice && tuesdayPrice != '0') {
      errorTmp[0].tuesdayPrice = t('Price Is Required.')
      isValid = false
    }
    if (!wednesdayPrice && wednesdayPrice != '0') {
      errorTmp[0].wednesdayPrice = t('Price Is Required.')
      isValid = false
    }
    if (!thursdayPrice && thursdayPrice != '0') {
      errorTmp[0].thursdayPrice = t('Price Is Required.')
      isValid = false
    }
    if (!fridayPrice && fridayPrice != '0') {
      errorTmp[0].fridayPrice = t('Price Is Required.')
      isValid = false
    }
    if (!saturdayPrice && saturdayPrice != '0') {
      errorTmp[0].saturdayPrice = t('Price Is Required.')
      isValid = false
    }
    if (!sundayPrice && sundayPrice != '0') {
      errorTmp[0].sundayPrice = t('Price Is Required.')
      isValid = false
    }

    setValidationErrors(errorTmp)
    return isValid
  }
  const handleSave = () => {
    if (!validateSpecialPrice()) {
      return
    }
    const newData = {
      fromDate,
      toDate,
      en_title,
      ru_title,
      uz_title,
      mondayPrice,
      tuesdayPrice,
      wednesdayPrice,
      thursdayPrice,
      fridayPrice,
      saturdayPrice,
      sundayPrice,
    }

    if (editIndex > -1) {
      const updatedData = specialPrice.map((item: any, index: any) =>
        index === editIndex ? newData : item
      )
      setSpecialPrice(updatedData)
      setEditIndex(-1)
    } else {
      setSpecialPrice([...specialPrice, newData])
    }

    resetForm()
  }

  const handleEdit = (index: any) => {
    const item = specialPrice[index]
    setFromDate(item.fromDate)
    setToDate(item.toDate)
    setEn_title(item.en_title)
    setRu_title(item.ru_title)
    setUz_title(item.uz_title)
    setMondayPrice(item.mondayPrice)
    setTuesdayPrice(item.tuesdayPrice)
    setWednesdayPrice(item.wednesdayPrice)
    setThursdayPrice(item.thursdayPrice)
    setFridayPrice(item.fridayPrice)
    setSaturdayPrice(item.saturdayPrice)
    setSundayPrice(item.sundayPrice)
    setEditIndex(index)
  }

  const handleRemove = (index: any) => {
    setSpecialPrice(specialPrice.filter((_: any, i: any) => i !== index))
    resetForm()
  }

  const resetForm = () => {
    setFromDate('')
    setToDate('')
    setEn_title('')
    setRu_title('')
    setUz_title('')
    setMondayPrice('0')
    setTuesdayPrice('0')
    setWednesdayPrice('0')
    setThursdayPrice('0')
    setFridayPrice('0')
    setSaturdayPrice('0')
    setSundayPrice('0')
    setEditIndex(-1)
  }
  // This effect ensures the editor is initialized before accessing it
  const handleImageChange = async (e: any) => {
    removeError('inputImage')
    const selectedFiles = Array.from(e.target.files)
    const validFiles = selectedFiles.filter((file: any) => {
      if (file.size > 5 * 1024 * 1024) {
        // 5 MB = 5 * 1024 * 1024 bytes
        toasterrormsg(`${file.name} ${t('is larger than 5 MB and was not added.')}`)
        return false
      }
      return true
    })
    const MAX_IMAGES = 15
    // Check if adding selected files will exceed the limit
    if (inputImage.length + validFiles.length > MAX_IMAGES) {
      // If it exceeds, only select files up to the limit
      const remainingCapacity = MAX_IMAGES - inputImage.length
      const limitedFiles = validFiles.slice(0, remainingCapacity)

      // Display a message or perform an action to notify the user about the limit
      toasterrormsg(t(`Maximum ${MAX_IMAGES} images can be uploaded.`))

      // Compress the images
      const processedFiles = await Promise.all(limitedFiles.map((file: any) => processImage(file)))

      // Store the processed file names as paths
      const filePaths = processedFiles.map((file) => file)

      // Append new images to the existing array of images
      setInputImage((prevImages: any) => [...prevImages, ...filePaths])
    } else {
      // If it doesn't exceed, proceed as before
      const processedFiles = await Promise.all(validFiles.map((file: any) => processImage(file)))
      const filePaths = processedFiles.map((file) => file)
      setInputImage((prevImages: any) => [...prevImages, ...filePaths])
    }
  }

  const processImage = async (imageFile: File) => {
    if (imageFile.size >= 2 * 1024 * 1024) {
      return await compressImage(imageFile)
    } else {
      return imageFile
    }
  }

  const compressImage = async (imageFile: File) => {
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1024,
      useWebWorker: true,
    }
    try {
      const compressedBlob = await imageCompression(imageFile, options)
      const extension = imageFile.name.split('.').pop()
      const newFileName = `${Date.now()}.${extension}`
      const compressedFile = new File([compressedBlob], newFileName, {
        type: compressedBlob.type,
        lastModified: Date.now(),
      })
      return compressedFile
    } catch (error) {
      console.error('Error compressing image:', error)
      return imageFile
    }
  }

  // function for remove selected images
  const handleRemove1 = (index1: any) => {
    let tmparrimg = inputImage.filter((item: any, index: any) => index != index1)

    setInputImage(tmparrimg)
  }

  // service language list api call
  const serviceLanguageListAPIcall = async () => {
    var param = {
      categoryId: '5',
    }
    var res = await fetchData('public/serviceLanguageList', param)

    if (res.status == '200') {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({value: val.servicelanguageId, label: getTranslatedValue(lang, val, '_name')})
      })
      setServiceLanguageList(opt)
    } else {
      toasterrormsg(res.message)
    }
  }
  //   region list api call
  const regionListAPIcall = async () => {
    var res = await fetchData('public/regionList', [])

    if (res.status == '200') {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({value: val.regionId, label: getTranslatedValue(lang, val, '_name')})
      })

      setRegionList(opt)
    } else {
      toasterrormsg(res.message)
    }
  }

  // included list api call
  const includedListAPIcall = async () => {
    var res = await fetchData('public/includedList', [])

    if (res.status == '200') {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({value: val.masterincludeId, label: getTranslatedValue(lang, val, '_name')})
      })

      setWhatsIncludedList(opt)
    } else {
      toasterrormsg(res.message)
    }
  }
  //   services list api call
  const serviceListAPIcall = async () => {
    var res = await fetchData('public/serviceList', [])

    if (res.status == '200') {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({value: val.serviceId, label: getTranslatedValue(lang, val, '_name')})
      })
      setServiceList(opt)
    } else {
      toasterrormsg(res.message)
    }
  }
  //   tour type List list api call
  const tourtypeListAPIcall = async () => {
    var res = await fetchData('public/tourtypeList', [])

    if (res.status == '200') {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({value: val.tourtypeId, label: getTranslatedValue(lang, val, '_name')})
      })
      setTourTypeList(opt)
    } else {
      toasterrormsg(res.message)
    }
  }
  // remove uplaoded images
  const handleRemoveImage = async (index: any) => {
    var param = {
      tourpackagemediaId: index,
    }
    var res = await fetchData('public/deleteTourPackageMedia', param)

    if (res.status == '200') {
      tourPackageDetailsApiCall()
    } else {
      toasterrormsg(res.message)
    }
  }

  const handleTextClick = () => {
    let element: HTMLElement = document.getElementsByClassName('modaldocument')[0] as HTMLElement
    element.click()
  }

  // validation function
  const basicInfoValidate = () => {
    var isValid = true
    var errorTmp = [...error]

    if (primaryLanguage == 'English') {
      if (tourNameEN.trim() == '' || tourNameEN.trim() == null || tourNameEN.trim() == undefined) {
        errorTmp[0].tourNameEN = t('Tour Name Is Required')
        isValid = false
      }
    } else if (primaryLanguage == 'Russian') {
      if (tourNameRU.trim() == '' || tourNameRU.trim() == null || tourNameRU.trim() == undefined) {
        errorTmp[0].tourNameRU = t('Tour Name Is Required')
        isValid = false
      }
    } else if (primaryLanguage == 'Uzbek') {
      if (tourNameUZ.trim() == '' || tourNameUZ.trim() == null || tourNameUZ.trim() == undefined) {
        errorTmp[0].tourNameUZ = t('Tour Name Is Required')
        isValid = false
      }
    }
    if (maxPeople == '' || maxPeople == null || maxPeople == undefined) {
      errorTmp[0].maxPeople = t('Max People Is Required')
      isValid = false
    } else if (parseInt(maxPeople) <= 0) {
      errorTmp[0].maxPeople = t('Max People Must Be Greater Than 0')
      isValid = false
    }
    if (tourTypeSelectedOptions.length == 0) {
      errorTmp[0].tourType = t('Tour Type Is Required')
      isValid = false
    }
    if (
      regionSelectedOptions == '' ||
      regionSelectedOptions == undefined ||
      regionSelectedOptions == null
    ) {
      errorTmp[0].regionId = t('Region Is Required')
      isValid = false
    }
    if (departureAddress == '' || departureAddress == null || departureAddress == undefined) {
      errorTmp[0].departureAddress = t('Location Is Required')
      isValid = false
    }
    setError(errorTmp)
    return isValid
  }
  const generalInfoValidate = () => {
    var isValid = true
    var errorTmp = [{...error[0]}] as any

    // treats an editor value that only holds empty markup (<p><br></p>, &nbsp;, ...) as empty
    const isEditorEmpty = (value: any) => {
      if (value == '' || value == null || value == undefined) return true
      return (
        String(value)
          .replace(/<[^>]*>/g, '')
          .replace(/&nbsp;/g, ' ')
          .trim() == ''
      )
    }

    const suffix =
      primaryLanguage == 'Russian' ? 'RU' : primaryLanguage == 'Uzbek' ? 'UZ' : 'EN'

    const highlight = suffix == 'RU' ? highlightRU : suffix == 'UZ' ? highlightUZ : highlightEN
    const itinarary = suffix == 'RU' ? itinararyRU : suffix == 'UZ' ? itinararyUZ : itinararyEN
    const whatToExpect =
      suffix == 'RU' ? whatToExpectRU : suffix == 'UZ' ? whatToExpectUZ : whatToExpectEN
    const meetingPoint =
      suffix == 'RU' ? meetingPointRU : suffix == 'UZ' ? meetingPointUZ : meetingPointEN
    const activityEssential =
      suffix == 'RU'
        ? activityEssentialRU
        : suffix == 'UZ'
        ? activityEssentialUZ
        : activityEssentialEN

    // clear the previous messages of the primary language before re-validating,
    // so a field that has been filled in does not keep showing its old error
    errorTmp[0]['highlight' + suffix] = ''
    errorTmp[0]['itinarary' + suffix] = ''
    errorTmp[0]['whatToExpect' + suffix] = ''
    errorTmp[0]['meetingPoint' + suffix] = ''
    errorTmp[0]['activityEssential' + suffix] = ''

    var highlightInvalid = isEditorEmpty(highlight)
    if (highlightInvalid) {
      errorTmp[0]['highlight' + suffix] = t('Activity Highlight Is Required')
      isValid = false
    }
    setActivityHighlightsAccordionShow(highlightInvalid)

    var itinararyInvalid = isEditorEmpty(itinarary)
    if (itinararyInvalid) {
      errorTmp[0]['itinarary' + suffix] = t('Itinarary Is Required')
      isValid = false
    }
    setItinararyAccordionShow(itinararyInvalid)

    var whatToExpectInvalid = isEditorEmpty(whatToExpect)
    if (whatToExpectInvalid) {
      errorTmp[0]['whatToExpect' + suffix] = t('This Field Is Required')
      isValid = false
    }
    setWhatToexpectAccordionShow(whatToExpectInvalid)

    var activityEssentialInvalid = isEditorEmpty(activityEssential)
    if (activityEssentialInvalid) {
      errorTmp[0]['activityEssential' + suffix] = t('Activity Essential Is Required')
      isValid = false
    }
    setActivityEssentialAccordionShow(activityEssentialInvalid)

    const newErrors = {} as any
    const nameKey = suffix == 'RU' ? 'ru_name' : suffix == 'UZ' ? 'uz_name' : 'en_name'
    var meetingPointInvalid = isEditorEmpty(meetingPoint)
    if (meetingPointInvalid) {
      errorTmp[0]['meetingPoint' + suffix] = t('Meeting Point Is Required')
      isValid = false
    }
    meetingPoints.forEach((meeting: any, index: any) => {
      if (!meeting[nameKey]) {
        newErrors[index] = {...newErrors[index], [nameKey]: t('Meeting Name Is Required')}
        isValid = false
        meetingPointInvalid = true
      }
    })
    setMeetingPointAccordionShow(meetingPointInvalid)

    setErrors(newErrors)
    setError(errorTmp)
    return isValid
  }
  const facilityAndServicesValidate = () => {
    var isValid = true
    var errorTmp = [...error]

    if (serviceSelectedOptions.length == 0) {
      errorTmp[0].service = t('Service Is Required')
      isValid = false
    }
    if (serviceLanguageSelectedOptions.length == 0) {
      errorTmp[0].serviceLanguage = t('Service Language Is Required')
      isValid = false
    }
    if (whatsIncludedSelectedOptions.length == 0) {
      errorTmp[0].whatsIncluded = t('Whats Included Is Required')
      isValid = false
    }

    setError(errorTmp)
    return isValid
  }
  const pricingAndAvailability = () => {
    var isValid = true
    var errorTmp = [...error]

    if (baseCharge == '' || baseCharge == null || baseCharge == undefined) {
      errorTmp[0].baseCharge = t('Tour Price Is Required')
      isValid = false
    } else if (!isOnlyNumber(baseCharge)) {
      errorTmp[0].baseCharge = t('Only Number Is Allowed')
      isValid = false
    }
    if (durationDay == '' || durationDay == null || durationDay == undefined) {
      errorTmp[0].durationDay = t('Duration Day Is Required')
      isValid = false
    }
    if (durationHour == '' || durationHour == null || durationHour == undefined) {
      errorTmp[0].durationHour = t('Duration Hour Is Required')
      isValid = false
    } else if (Number(durationHour) > 24) {
      errorTmp[0].durationHour = t('Duration Hour Must Be Less Than Or Equal To 24')
      isValid = false
    }
    // Everything above is filled on the Regular Price sub-tab, so tell the user when its errors are not visible
    setPriceStepError(
      !isValid && priceTab !== 'RegularPrice'
        ? t('There is a mistake in filling details at Regular Price stage, please check and fix first.')
        : ''
    )
    if (!isYear) {
      if (fromAvailableDate == '' || fromAvailableDate == null || fromAvailableDate == undefined) {
        errorTmp[0].fromAvailableDate = t('From Available Date Is Required')
        isValid = false
      }
      if (toAvailableDate == '' || toAvailableDate == null || toAvailableDate == undefined) {
        errorTmp[0].toAvailableDate = t('To Available Date Is Required')
        isValid = false
      } else if (fromAvailableDate >= toAvailableDate) {
        errorTmp[0].toAvailableDate = t(
          'To Available Date Must Be Greater Than From Available Date'
        )
        isValid = false
      }
    }

    setError(errorTmp)
    return isValid
  }
  const tourPhotosValidate = () => {
    var isValid = true
    var errorTmp = [...error]

    if (uploadedImage.length < 2) {
      if (inputImage.length == 0) {
        errorTmp[0].inputImage = t('Tour Images Is Required')
        isValid = false
      } else if (inputImage.length < 2) {
        errorTmp[0].inputImage = t('Minimum 3 Images Is Required')
        isValid = false
      }
    }

    setError(errorTmp)
    return isValid
  }

  const handleTabChange = (nextTab: any) => {
    let isValid = true

    if (isNextTab(nextTab)) {
      switch (tab) {
        case 'BasicInfo':
          isValid = basicInfoValidate()
          break
        case 'TourDetails':
          isValid = generalInfoValidate()
          break
        case 'FacilityAndServices':
          isValid = facilityAndServicesValidate()
          break
        case 'PricingAndAvailability':
          isValid = pricingAndAvailability()
          break
        case 'TourPhotos':
          isValid = tourPhotosValidate() // Assuming you have a function tourPhotosvalidate()
          break
        default:
          break
      }
    }

    if (isValid) {
      setTab(nextTab)
    }
  }

  const isNextTab = (nextTab: any) => {
    const tabOrder = [
      'BasicInfo',
      'TourDetails',
      'FacilityAndServices',
      'PricingAndAvailability',
      'TourPhotos',
    ]
    return tabOrder.indexOf(nextTab) > tabOrder.indexOf(tab)
  }

  const nextToGeneralInfo = () => {
    handleTabChange('TourDetails')
  }

  const nextToFacilityAndServices = () => {
    handleTabChange('FacilityAndServices')
  }

  const nextToPricingAndAvailability = () => {
    handleTabChange('PricingAndAvailability')
  }

  const nextToTourPhotos = () => {
    handleTabChange('TourPhotos')
  }

  // ------------------------------------- apis call ------------------------------------
  // hotel Details api call
  const tourPackageDetailsApiCall = async () => {
    var param: any = {
      tourpackageId: editTourpackageId,
    }
    var response: any = await fetchData('public/tourpackageDetails', param)

    if (response.status == '200') {
      var tourList = response.data[0]['toursDetail']
      setTourPackageDetail(tourList)
      setTourPackageDetails(response.data)
      setPrimLanguage(response.data[0]['primaryLanguage'])
      var tmp: any = tourList.slice(offset, offset + limit)
      setDisplayTourList(tmp)
      var totpag = Math.ceil(tourList.length / limit)
      setTotalPage(totpag)
      if (totpag == 1) {
        var mod = tourList.length % limit
        if (mod > 0) {
          setTo(mod)
        } else {
          setTo(tmp.length)
        }
      } else {
        var mod = tourList.length % limit
        if (mod > 0) {
          setTo(page * limit + mod)
        } else {
          setTo(page * limit)
        }
      }
      var genpag = generatePageNumbers(page, totpag, 6)
      setPageNumberList(genpag)

      if (editToursId != '') {
        var tours = tourList.find((value: any) => value['toursId'] === editToursId)

        setTourNameEN(tours['en_name'])
        setTourNameRU(tours['ru_name'])
        setTourNameUZ(tours['uz_name'])
        setMaxPeople(tours['maxPeople'])
        var tourT = tours.tourType.split(',')
        var tourType = tourTypeList.filter((value: any) => tourT.includes(value.value + ''))
        setTourTypeSelectedOptions(tourType)
        setDepartureAddress(tours['departureLocation'])
        setDepartureCity(tours['departureCity'])
        setDepartureCountry(tours['departureCountry'])
        setDepartureState(tours['departureState'])
        setDepartureLatitude(tours['departureLatitude'])
        setDepartureLongitude(tours['departureLongitude'])
        setHighlightEN(tours['en_highlight'])
        setHighlightRU(tours['ru_highlight'])
        setHighlightUZ(tours['uz_highlight'])
        setItinararyEN(tours['en_itinarary'])
        setItinararyRU(tours['ru_itinarary'])
        setItinararyUZ(tours['uz_itinarary'])
        setWhatToExpectEN(tours['en_whatToExpect'])
        setWhatToExpectRU(tours['ru_whatToExpect'])
        setWhatToExpectUZ(tours['uz_whatToExpect'])
        setMeetingPointEN(tours['en_meetingPoint'])
        setMeetingPointRU(tours['ru_meetingPoint'])
        setMeetingPointUZ(tours['uz_meetingPoint'])
        if (tours['meetingPoints'].length > 0) {
          setMeetingPoints(tours['meetingPoints'])
        }
        setActivityEssentialEN(tours['en_activityEssential'])
        setActivityEssentialRU(tours['ru_activityEssential'])
        setActivityEssentialUZ(tours['uz_activityEssential'])

        var services: any = []
        tours['services'].map((val: any) => {
          services.push({value: val.serviceId, label: getTranslatedValue(lang, val, '_name')})
        })
        console.log(tours)

        setServiceSelectedOptions(services)
        var region: any = []
        tours['departureRegionDetail'].map((val: any) => {
          region.push({value: val.regionId, label: getTranslatedValue(lang, val, '_name')})
        })
        setRegionSelectedOptions(region[0] ? region[0] : [])
        var serviceLanguage: any = []
        tours.serviceLanguageDetail.map((val: any) => {
          serviceLanguage.push({
            value: val.servicelanguageId,
            label: getTranslatedValue(lang, val, '_name'),
          })
        })
        setServiceLanguageSelectedOptions(serviceLanguage)

        var whatsIncluded: any = []
        tours['included'].map((val: any) => {
          whatsIncluded.push({
            value: val.masterincludeId,
            label: getTranslatedValue(lang, val, '_name'),
          })
        })
        setWhatsIncludedSelectedOptions(whatsIncluded)

        var whatsNotIncluded: any = []
        tours['notIncluded'].map((val: any) => {
          whatsNotIncluded.push({
            value: val.masterincludeId,
            label: getTranslatedValue(lang, val, '_name'),
          })
        })
        setWhatsNotIncludedSelectedOptions(whatsNotIncluded)
        setBaseCharge(tours['price'])
        setDurationDay(tours['durationDay'])
        setDurationHour(tours['durationHour'])
        setIsYear(tours['isYear'] && tours['isYear'] == '1' ? true : false)
        if (tours['isYear'] != '1') {
          setFromAvailableDate(tours['fromAvailableDate'].split('T')[0])
          setToAvailableDate(tours['toAvailableDate'].split('T')[0])
        }
        setUploadedImage(tours['images'])
        if (tours['specialPriceDetail'].length > 0) {
          setSpecialPrice(tours['specialPriceDetail'])
        }
      }
    } else {
      toasterrormsg(response.message)
    }
  }

  // add room api call
  const addTourDetailApi = async () => {
    if (tourPhotosValidate()) {
      setDisable(true)
      setLoading(true)
      let param = new FormData()
      param.append('tourpackageId', editTourpackageId)
      param.append('en_name', tourNameEN)
      param.append('ru_name', tourNameRU)
      param.append('uz_name', tourNameUZ)
      param.append('tourType', tourType)
      param.append('maxPeople', maxPeople)
      param.append('departureLocation', departureAddress)
      param.append('departureCountry', departureCountry)
      param.append('departureState', departureState)
      param.append('departureCity', departureCity)
      param.append('departureLongitude', departureLongitude)
      param.append('departureLatitude', departureLatitude)
      param.append('departureRegionId', regionSelectedOptions.value)
      param.append('en_highlight', highlightEN)
      param.append('ru_highlight', highlightRU)
      param.append('uz_highlight', highlightUZ)
      param.append('en_itinarary', itinararyEN)
      param.append('ru_itinarary', itinararyRU)
      param.append('uz_itinarary', itinararyUZ)
      param.append('en_whatToExpect', whatToExpectEN)
      param.append('ru_whatToExpect', whatToExpectRU)
      param.append('uz_whatToExpect', whatToExpectUZ)
      param.append('en_meetingPoint', meetingPointEN)
      param.append('ru_meetingPoint', meetingPointRU)
      param.append('uz_meetingPoint', meetingPointUZ)
      param.append('meetingPoints', JSON.stringify(meetingPoints))
      param.append('en_activityEssential', activityEssentialEN)
      param.append('ru_activityEssential', activityEssentialRU)
      param.append('uz_activityEssential', activityEssentialUZ)
      param.append('service', serviceId)
      param.append('serviceLanguage', serviceLanguage)
      param.append('included', whatsIncluded)
      param.append('notIncluded', whatsNotIncluded)
      param.append('tourPrice', baseCharge)
      param.append('durationDay', durationDay)
      param.append('durationHour', durationHour)
      param.append('isYear', isYear ? '1' : '0')
      param.append('specialPrice', JSON.stringify(specialPrice))
      if (!isYear) {
        param.append('fromAvailableDate', fromAvailableDate)
        param.append('toAvailableDate', toAvailableDate)
      }
      if (inputImage.length != 0) {
        inputImage.forEach((file: any) => {
          param.append('image', file)
        })
      }

      var res = await fetchFormData('public/addTourDetail', param)

      if (res.status == '200') {
        toastsuccessmsg(t('Tour Added Successfully!'))
        tourPackageDetailsApiCall()
        handleClose()
        cleanStates()
        setDisable(false)
        setLoading(false)
      } else {
        setLoading(false)
        toasterrormsg(res.message)
        setDisable(false)
      }
    }
  }
  //   delete hotel api call
  const confirmdelete = (toursId: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t('You Want To Delete'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('Yes'),
      cancelButtonText: t('No'),
    }).then(async (result) => {
      if (result.isConfirmed) {
        var param = {
          toursId: toursId,
        }
        var res = await fetchData('public/deleteTours', param)

        if (res.status == '200') {
          tourPackageDetailsApiCall()
        } else {
          toasterrormsg(res.message)
        }
      }
    })
  }
  const editModalOpen = (toursId: any) => {
    setEditToursId(toursId)
    handleShow()
  }
  useEffect(() => {
    tourtypeListAPIcall()
    serviceListAPIcall()
    includedListAPIcall()
    regionListAPIcall()
    serviceLanguageListAPIcall()
  }, [])
  useEffect(() => {
    tourPackageDetailsApiCall()
  }, [editToursId])
  // edit room api call
  const editTourDetailApi = async () => {
    if (tourPhotosValidate()) {
      setDisable(true)
      setLoading(true)
      let param = new FormData()
      param.append('tourpackageId', editTourpackageId)
      param.append('toursId', editToursId)
      param.append('en_name', tourNameEN)
      param.append('ru_name', tourNameRU)
      param.append('uz_name', tourNameUZ)
      param.append('tourType', tourType)
      param.append('maxPeople', maxPeople)
      param.append('departureLocation', departureAddress)
      param.append('departureCountry', departureCountry)
      param.append('departureState', departureState)
      param.append('departureCity', departureCity)
      param.append('departureLongitude', departureLongitude)
      param.append('departureLatitude', departureLatitude)
      param.append('departureRegionId', regionSelectedOptions.value)
      param.append('en_highlight', highlightEN)
      param.append('ru_highlight', highlightRU)
      param.append('uz_highlight', highlightUZ)
      param.append('en_itinarary', itinararyEN)
      param.append('ru_itinarary', itinararyRU)
      param.append('uz_itinarary', itinararyUZ)
      param.append('en_whatToExpect', whatToExpectEN)
      param.append('ru_whatToExpect', whatToExpectRU)
      param.append('uz_whatToExpect', whatToExpectUZ)
      param.append('en_meetingPoint', meetingPointEN)
      param.append('ru_meetingPoint', meetingPointRU)
      param.append('uz_meetingPoint', meetingPointUZ)
      param.append('meetingPoints', JSON.stringify(meetingPoints))
      param.append('en_activityEssential', activityEssentialEN)
      param.append('ru_activityEssential', activityEssentialRU)
      param.append('uz_activityEssential', activityEssentialUZ)
      param.append('service', serviceId)
      param.append('serviceLanguage', serviceLanguage)
      param.append('included', whatsIncluded)
      param.append('notIncluded', whatsNotIncluded)
      param.append('tourPrice', baseCharge)
      param.append('durationDay', durationDay)
      param.append('durationHour', durationHour)
      param.append('isYear', isYear ? '1' : '0')
      param.append('specialPrice', JSON.stringify(specialPrice))
      if (!isYear) {
        param.append('fromAvailableDate', fromAvailableDate)
        param.append('toAvailableDate', toAvailableDate)
      }

      if (inputImage.length != 0) {
        inputImage.forEach((file: any) => {
          param.append('image', file)
        })
      }

      var res = await fetchFormData('public/addTourDetail', param)

      if (res.status == '200') {
        toastsuccessmsg(t('Tour Saved Successfully!'))
        tourPackageDetailsApiCall()
        handleClose()
        cleanStates()
        setDisable(false)
        setLoading(false)
      } else {
        setLoading(false)
        toasterrormsg(res.message)
        setDisable(false)
      }
    }
  }

  const cleanStates = () => {
    setLoading(false)
    setTourNameEN('')
    setTourNameRU('')
    setTourNameUZ('')
    setMaxPeople('')
    setTab('BasicInfo')
    setBaseCharge('')
    setIsYear(false)
    setFromAvailableDate('')
    setToAvailableDate('')
    setTourTypeSelectedOptions([])
    setServiceSelectedOptions([])
    setServiceLanguageSelectedOptions([])
    setWhatsIncludedSelectedOptions([])
    setWhatsNotIncludedSelectedOptions([])
    setRegionSelectedOptions([])
    setMeetingPoints([{en_name: '', ru_name: '', uz_name: ''}])
    setErrors({en_name: '', ru_name: '', uz_name: ''})
    setDepartureCountry('')
    setDepartureState('')
    setDepartureCity('')
    setDepartureAddress('')
    setDepartureLongitude('')
    setDepartureLatitude('')
    setDurationDay('')
    setDurationHour('')
    setFromAvailableDate('')
    setHighlightEN('')
    setHighlightRU('')
    setHighlightUZ('')
    setItinararyEN('')
    setItinararyRU('')
    setItinararyUZ('')
    setWhatToExpectEN('')
    setWhatToExpectRU('')
    setWhatToExpectUZ('')
    setMeetingPointEN('')
    setMeetingPointRU('')
    setMeetingPointUZ('')
    setActivityEssentialEN('')
    setActivityEssentialRU('')
    setActivityEssentialUZ('')
    setInputImage([])
    setUploadedImage([])
    resetForm()
    setPriceTab('RegularPrice')
    setSpecialPrice([])
    removeError('departureAddress')
    removeError('tourNameEN')
    removeError('tourNameRU')
    removeError('tourNameUZ')
    removeError('tourType')
    removeError('regionId')
    removeError('highlightEN')
    removeError('highlightRU')
    removeError('highlightUZ')
    removeError('itinararyEN')
    removeError('itinararyRU')
    removeError('itinararyUZ')
    removeError('whatToExpectEN')
    removeError('whatToExpectRU')
    removeError('whatToExpectUZ')
    removeError('meetingPointEN')
    removeError('meetingPointRU')
    removeError('meetingPointUZ')
    removeError('activityEssentialEN')
    removeError('activityEssentialRU')
    removeError('activityEssentialUZ')
    removeError('whatsIncluded')
    removeError('service')
    removeError('serviceLanguage')
    removeError('maxPeople')
    removeError('baseCharge')
    removeError('inputImage')
    removeError('durationDay')
    removeError('durationHour')
    removeError('availableDate')
  }
  useEffect(() => {
    const modal = document.querySelector('.modal')
    if (modal) {
      modal.removeAttribute('tabindex')
    }
  }, [show])
  return (
    <>
      <PageTitle breadcrumbs={[]}>{t('View Tours')}</PageTitle>
      <ToastContainer />
      <AddTourPackageHeader tourpackageId={editTourpackageId} />
      <div className='d-flex flex-column'>
        {/* <!--begin::General options--> */}
        <div className='card card-flush py-4'>
          {/* <!--begin::Card header--> */}
          <div className='card-header d-flex'>
            {/* <!--begin::Card title--> */}
            <div className='card-title'>
              <h2>{t('Tours Details')}</h2>
            </div>
            {/* <!--end::Card title--> */}
            <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
              {tourPackageDetails.length != 0 ? (
                <>
                  {tourPackageDetails.map((completedSteps: any, index: any) => {
                    var percentage = 0
                    if (completedSteps['completedSteps']['basicInfo']) {
                      percentage = 10
                    }
                    if (completedSteps['completedSteps']['location']) {
                      percentage = 20
                    }
                    if (completedSteps['completedSteps']['toursDetail']) {
                      percentage = 60
                    }
                    if (completedSteps['completedSteps']['photos']) {
                      percentage = 70
                    }
                    if (completedSteps['completedSteps']['policies']) {
                      percentage = 90
                    }
                    if (completedSteps['completedSteps']['financeAndLegal']) {
                      percentage = 100
                    }
                    return (
                      <React.Fragment key={index}>
                        <div className='d-flex justify-content-between w-100 mt-auto'>
                          <span className='fw-bold fs-6'>{t('Completion')}</span>
                          <span className='fw-bolder fs-6'>{percentage}%</span>
                        </div>
                        <div className='h-5px mx-3 w-100 bg-light mb-3'>
                          <div
                            className='bg-success rounded h-5px'
                            role='progressbar'
                            style={{width: `${percentage}%`}}
                          ></div>
                        </div>
                      </React.Fragment>
                    )
                  })}
                </>
              ) : (
                <>
                  <div className='d-flex justify-content-between w-100 mt-auto'>
                    <span className='fw-bold fs-6'>{t('Completion')}</span>
                    <span className='fw-bolder fs-6'>0%</span>
                  </div>
                  <div className='h-5px mx-3 w-100 bg-light mb-3'>
                    <div
                      className='bg-success rounded h-5px'
                      role='progressbar'
                      style={{width: '0%'}}
                    ></div>
                  </div>
                </>
              )}
            </div>
          </div>
          {/* <!--end::Card header--> */}
          <div className='d-flex justify-content-end mx-10 mt-3'>
            <button
              className='btn text-white cursor-pointer btn-primary'
              id='kt_toolbar_primary_button'
              style={{color: 'rgb(24, 28, 50)'}}
              onClick={handleShow}
            >
              + {t('Add Tours')}
            </button>
          </div>
        </div>
        {/* <!--end::Pricing--> */}
      </div>
      {/* begin::Row */}
      <div className='row g-5 g-xl-8 mt-3'>
        {displayTourList.map((tour: any, index: any) => {
          var description = getTranslatedValue(lang, tour, '_highlight', primLanguage)
          var tourName = getTranslatedValue(lang, tour, '_name', primLanguage)
          return (
            <div className='col-xl-4' key={index}>
              <MixedWidget24
                className='card-xl-stretch mb-5 mb-xl-8'
                color='success'
                toursId={tour['toursId']}
                deleteTours={confirmdelete}
                editModalOpen={editModalOpen}
                tourName={tourName}
                image={
                  tour['images'].length != 0
                    ? tour['images'][0].thumbPath
                    : toAbsoluteUrl('/media/logos/InsayrLogo.png')
                }
                description={description}
                maxPeople={tour['maxPeople']}
                progress='100%'
              />
            </div>
          )
        })}
      </div>
      {tourPackageDetail.length != 0 ? (
        <>
          <div className='d-flex flex-stack flex-wrap pt-10'>
            <div className='fs-6 fw-bold text-gray-700'>
              {t('Showing [from] to [to] of [total] entries').replace('[from]', String(from)).replace('[to]', String(to)).replace('[total]', String(tourPackageDetail.length))}
            </div>

            <ul className='pagination'>
              <li className={`page-item previous ${page > 1 ? '' : 'disabled'}`}>
                <span
                  className={`page-link ${page > 1 ? 'cursor-pointer' : 'disabled'}`}
                  onClick={() => onpagecahnge(page - 1)}
                >
                  <i className='previous'></i>
                </span>
              </li>
              {pageNumbersList.map((item: any, index: any) => {
                return (
                  <li
                    className={`page-item cursor-pointer ${page == item ? 'active' : ''}`}
                    key={index}
                  >
                    <span className='page-link' onClick={() => onpagecahnge(item)}>
                      {item}
                    </span>
                  </li>
                )
              })}

              <li className={`page-item next ${page + 1 <= totalPage ? '' : 'disabled'}`}>
                <span
                  className={`page-link ${page + 1 <= totalPage ? 'cursor-pointer' : 'disabled'}`}
                  onClick={() => (page + 1 <= totalPage ? onpagecahnge(page + 1) : '')}
                >
                  <i className='next'></i>
                </span>
              </li>
            </ul>
          </div>
          <div className='row my-10'>
            <div className='col-lg-12 text-end'>
              <Link
                to={'../addtourpackagephotos/'}
                state={{tourpackageId: editTourpackageId}}
                className='btn btn-primary'
              >
                {t('Next')}
              </Link>
            </div>
          </div>
        </>
      ) : (
        ''
      )}
      {/* end::Row */}
      <Modal show={show} onHide={handleClose} backdrop='static' keyboard={false}>
        <div
          className='modal fade show'
          id='kt_modal_tours'
          tabIndex={-1}
          style={{display: 'block'}}
          aria-modal='true'
          role='dialog'
        >
          {/* <!--begin::Modal dialog--> */}
          <div className='modal-dialog modal-dialog-centered mw-950px'>
            {/* <!--begin::Modal content--> */}
            <div className='modal-content'>
              {/* <!--begin::Form--> */}
              <div className='form' id='kt_modal_upload_form'>
                {/* <!--begin::Modal header--> */}
                <div className='modal-header d-flex justify-content-between'>
                  {/* <!--begin::Modal title--> */}
                  <h2 className='fw-bold'>
                    {' '}
                    {editToursId != '' ? t('Edit Tours') : t('Add Tours')}
                  </h2>
                  {/* <!--end::Modal title--> */}
                  {/* <!--begin::Close--> */}
                  <div
                    className='btn btn-icon btn-sm btn-active-icon-primary'
                    onClick={handleClose}
                  >
                    <i className='ki-duotone ki-cross fs-1'>
                      <span className='path1'></span>
                      <span className='path2'></span>
                    </i>
                  </div>
                  {/* <!--end::Close--> */}
                </div>
                <div className='card card-custom'>
                  <div className='card-header card-header-stretch overflow-auto'>
                    <ul
                      className='nav nav-stretch nav-line-tabs fw-semibold border-transparent flex-nowrap'
                      role='tablist'
                    >
                      <li className='nav-item'>
                        <a
                          className={clsx(`nav-link cursor-pointer`, {active: tab === 'BasicInfo'})}
                          onClick={() => setTab('BasicInfo')}
                          role='tab'
                        >
                          {t('Basic Info')}
                        </a>
                      </li>
                      <li className='nav-item'>
                        <a
                          className={clsx(`nav-link cursor-pointer`, {
                            active: tab === 'TourDetails',
                          })}
                          onClick={nextToGeneralInfo}
                          role='tab'
                        >
                          {t('Tour Details')}
                        </a>
                      </li>
                      <li className='nav-item'>
                        <a
                          className={clsx(`nav-link cursor-pointer`, {
                            active: tab === 'FacilityAndServices',
                          })}
                          onClick={nextToFacilityAndServices}
                          role='tab'
                        >
                          {t('Facility & Services')}
                        </a>
                      </li>
                      <li className='nav-item'>
                        <a
                          className={clsx(`nav-link cursor-pointer`, {
                            active: tab === 'PricingAndAvailability',
                          })}
                          onClick={nextToPricingAndAvailability}
                          role='tab'
                        >
                          {t('Pricing & Availability')}
                        </a>
                      </li>
                      <li className='nav-item'>
                        <a
                          className={clsx(`nav-link cursor-pointer`, {
                            active: tab === 'TourPhotos',
                          })}
                          onClick={nextToTourPhotos}
                          role='tab'
                        >
                          {t('Tour Photos')}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* <!--end::Modal header--> */}
                {/* <!--begin::Modal body--> */}
                <div className='modal-body pt-10 pb-15 px-lg-17'>
                  {/* <!--begin::Input group--> */}
                  <div className='form-group'>
                    {/* <!--begin::Dropzone--> */}
                    <div className='dropzone dropzone-queue mb-2' id='kt_modal_upload_dropzone'>
                      {/* <!--begin::Controls--> */}
                      <div className='dropzone-panel mb-4'>
                        <div className='tab-content'>
                          <div className={clsx('tab-pane', {active: tab === 'BasicInfo'})}>
                            {primaryLanguage == 'English' && (
                              <>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='required fs-5 form-label'>
                                      {t('Tour Name (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='tourNameEN'
                                      className='form-control mb-2'
                                      placeholder={t('Tour Name')}
                                      value={tourNameEN}
                                      onChange={(e) => {
                                        setTourNameEN(e.target.value)
                                        removeError('tourNameEN')
                                      }}
                                    />
                                    <div className='text-danger fw-bold'>{error[0].tourNameEN}</div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-5 form-label'>
                                      {t('Tour Name (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='tourNameRU'
                                      className='form-control mb-2'
                                      placeholder={t('Tour Name')}
                                      value={tourNameRU}
                                      onChange={(e) => {
                                        setTourNameRU(e.target.value)
                                      }}
                                    />
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-5 form-label'>
                                      {t('Tour Name (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='tourNameUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Tour Name')}
                                      value={tourNameUZ}
                                      onChange={(e) => {
                                        setTourNameUZ(e.target.value)
                                      }}
                                    />
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                              </>
                            )}
                            {primaryLanguage == 'Russian' && (
                              <>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='required fs-5 form-label'>
                                      {t('Tour Name (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='tourNameRU'
                                      className='form-control mb-2'
                                      placeholder={t('Tour Name')}
                                      value={tourNameRU}
                                      onChange={(e) => {
                                        setTourNameRU(e.target.value)
                                        removeError('tourNameRU')
                                      }}
                                    />
                                    <div className='text-danger fw-bold'>{error[0].tourNameRU}</div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className=' fs-5 form-label'>
                                      {t('Tour Name (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='tourNameEN'
                                      className='form-control mb-2'
                                      placeholder={t('Tour Name')}
                                      value={tourNameEN}
                                      onChange={(e) => {
                                        setTourNameEN(e.target.value)
                                      }}
                                    />
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-5 form-label'>
                                      {t('Tour Name (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='tourNameUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Tour Name')}
                                      value={tourNameUZ}
                                      onChange={(e) => {
                                        setTourNameUZ(e.target.value)
                                      }}
                                    />
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                              </>
                            )}
                            {primaryLanguage == 'Uzbek' && (
                              <>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='required fs-5 form-label'>
                                      {t('Tour Name (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='tourNameUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Tour Name')}
                                      value={tourNameUZ}
                                      onChange={(e) => {
                                        setTourNameUZ(e.target.value)
                                        removeError('tourNameUZ')
                                      }}
                                    />
                                    <div className='text-danger fw-bold'>{error[0].tourNameUZ}</div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className=' fs-5 form-label'>
                                      {t('Tour Name (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='tourNameRU'
                                      className='form-control mb-2'
                                      placeholder={t('Tour Name')}
                                      value={tourNameRU}
                                      onChange={(e) => {
                                        setTourNameRU(e.target.value)
                                      }}
                                    />
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className=' fs-5 form-label'>
                                      {t('Tour Name (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='tourNameEN'
                                      className='form-control mb-2'
                                      placeholder={t('Tour Name')}
                                      value={tourNameEN}
                                      onChange={(e) => {
                                        setTourNameEN(e.target.value)
                                      }}
                                    />
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                              </>
                            )}
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-5 form-label'>
                                  {t('Max People')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='maxPeople'
                                  className='form-control mb-2'
                                  placeholder={t('Max People')}
                                  value={maxPeople}
                                  onChange={(e) => {
                                    setMaxPeople(e.target.value)
                                    removeError('maxPeople')
                                  }}
                                />
                                <div className='text-danger fw-bold'>{error[0].maxPeople}</div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label required'>{t('Tour Type')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <Select
                                  name='tourTypeList[]'
                                  id='tourTypeList'
                                  placeholder={t('Select Tour Type')}
                                  isSearchable={true}
                                  isMulti
                                  options={tourTypeList}
                                  value={tourTypeSelectedOptions}
                                  onChange={(e: any) => {
                                    setTourTypeSelectedOptions(e)
                                    removeError('tourType')
                                  }}
                                />
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>{error[0].tourType}</div>
                              </div>
                              <div className='col-lg-6 my-3'>
                                <label className='required fs-4 form-label'>
                                  {t('Tour Departure Location')}
                                </label>
                                <AutoComplete3
                                  name='location'
                                  id='location'
                                  placeholder={t('Enter Location')}
                                  value={departureAddress}
                                  onAddressSelect={(departureAddress: any) => {
                                    setDepartureAddress(departureAddress)
                                    removeError('departureAddress')
                                  }}
                                  longitude={(lng: any) => setDepartureLongitude(lng)}
                                  latitude={(lat: any) => setDepartureLatitude(lat)}
                                  country={(cnt: any) => setDepartureCountry(cnt)}
                                  state={(st: any) => setDepartureState(st)}
                                  city={(ct: any) => setDepartureCity(ct)}
                                />
                                <div className='text-danger fw-bold'>
                                  {error[0].departureAddress}
                                </div>
                                <br />
                                <GoogleMapComponent2
                                  latitude={departureLatitude}
                                  longitude={departureLongitude}
                                  onSelectLocation={(e: any) => setLocationObj(e)}
                                />
                              </div>
                              <div className='col-lg-6 my-3'>
                                <label className='required fs-4 form-label'>{t('Region')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <Select
                                  name='region[]'
                                  id='regionListId'
                                  placeholder={t('Select Region')}
                                  isSearchable={true}
                                  options={regionList}
                                  value={regionSelectedOptions}
                                  onChange={(e: any) => {
                                    setRegionSelectedOptions(e)
                                    removeError('regionId')
                                  }}
                                />
                                <div className='text-danger fw-bold'>{error[0].regionId}</div>
                              </div>
                            </div>
                            <div className='row'>
                              <div className='col-lg-12'>
                                <div className='d-flex flex-wrap justify-content-end pb-lg-0'>
                                  <button
                                    type='button'
                                    className='btn btn-light-primary me-4'
                                    onClick={handleClose}
                                  >
                                    {t('Cancel')}
                                  </button>
                                  <button
                                    type='button'
                                    disabled={disable}
                                    className='btn btn-primary me-4'
                                    onClick={nextToGeneralInfo}
                                  >
                                    <span className='indicator-label'>{t('Next')}</span>
                                    {loading && (
                                      <span
                                        className='spinner-border spinner-border-sm mx-2'
                                        role='status'
                                        aria-hidden='true'
                                      ></span>
                                    )}
                                  </button>{' '}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='tab-content'>
                          <div className={clsx('tab-pane', {active: tab === 'TourDetails'})}>
                            <div className='row'>
                              {/* activity highlights */}
                              <div className='accordion p-0' id='accordionPanelsStayOpenExample'>
                                <div className='accordion-item'>
                                  <h2 className='accordion-header' id='activity-highlights-header'>
                                    <button
                                      className='accordion-button text-dark text-hover-dark fw-bold fs-3'
                                      type='button'
                                      data-bs-toggle='collapse'
                                      data-bs-target='#activity-highlights-collapse'
                                      aria-expanded='true'
                                      aria-controls='activity-highlights-collapse'
                                    >
                                      {t('Activity Highlights')}
                                    </button>
                                  </h2>
                                  <div
                                    id='activity-highlights-collapse'
                                    className={`accordion-collapse collapse ${
                                      activityHighlightsAccordionShow ? 'show' : ''
                                    }`}
                                    aria-labelledby='activity-highlights-header'
                                  >
                                    <div className='accordion-body'>
                                      <p className='text-success fw-bolder fs-6'>
                                        {t(
                                          'Summarize the key attractions and experiences of your tour package in bullet points. Mention the most exciting parts of the tour to grab attention.'
                                        )}
                                      </p>
                                      {primaryLanguage == 'English' && (
                                        <>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className='required fs-5 form-label'>
                                              {t('Activity Highlight (English)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={highlightEN}
                                              onBlur={(newContent) => {
                                                setHighlightEN(newContent)
                                                removeError('highlightEN')
                                              }}
                                              onChange={() => {
                                                if (error[0].highlightEN) {
                                                  removeError('highlightEN')
                                                }
                                              }}
                                            />
                                            <div className='text-danger fw-bold'>
                                              {error[0].highlightEN}
                                            </div>
                                            {/* <!--end::Input--> */}
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className=' fs-5 form-label'>
                                              {t('Activity Highlight (Russian)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={highlightRU}
                                              onBlur={(newContent) => {
                                                setHighlightRU(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className=' fs-5 form-label'>
                                              {t('Activity Highlight (Uzbek)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={highlightUZ}
                                              onBlur={(newContent) => {
                                                setHighlightUZ(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                        </>
                                      )}
                                      {primaryLanguage == 'Russian' && (
                                        <>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className='required fs-5 form-label'>
                                              {t('Activity Highlight (Russian)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={highlightRU}
                                              onBlur={(newContent) => {
                                                setHighlightRU(newContent)
                                                removeError('highlightRU')
                                              }}
                                              onChange={() => {
                                                if (error[0].highlightRU) {
                                                  removeError('highlightRU')
                                                }
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                            <div className='text-danger fw-bold'>
                                              {error[0].highlightRU}
                                            </div>
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className='fs-5 form-label'>
                                              {t('Activity Highlight (English)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={highlightEN}
                                              onBlur={(newContent) => {
                                                setHighlightEN(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className=' fs-5 form-label'>
                                              {t('Activity Highlight (Uzbek)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={highlightUZ}
                                              onBlur={(newContent) => {
                                                setHighlightUZ(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                        </>
                                      )}
                                      {primaryLanguage == 'Uzbek' && (
                                        <>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className='required fs-5 form-label'>
                                              {t('Activity Highlight (Uzbek)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={highlightUZ}
                                              onBlur={(newContent) => {
                                                setHighlightUZ(newContent)
                                                removeError('highlightUZ')
                                              }}
                                              onChange={() => {
                                                if (error[0].highlightUZ) {
                                                  removeError('highlightUZ')
                                                }
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                            <div className='text-danger fw-bold'>
                                              {error[0].highlightUZ}
                                            </div>
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className='fs-5 form-label'>
                                              {t('Activity Highlight (Russian)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={highlightRU}
                                              onBlur={(newContent) => {
                                                setHighlightRU(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className='fs-5 form-label'>
                                              {t('Activity Highlight (English)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={highlightEN}
                                              onBlur={(newContent) => {
                                                setHighlightEN(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                {/* itinarary */}
                                <div className='accordion-item'>
                                  <h2 className='accordion-header' id='itinarary-header'>
                                    <button
                                      className='accordion-button collapsed  text-dark fw-bold fs-3'
                                      type='button'
                                      data-bs-toggle='collapse'
                                      data-bs-target='#itinarary-collapse'
                                      aria-expanded='false'
                                      aria-controls='itinarary-collapse'
                                    >
                                      {t('Itinarary')}
                                    </button>
                                  </h2>
                                  <div
                                    id='itinarary-collapse'
                                    className={`accordion-collapse collapse ${
                                      itinararyAccordionShow ? 'show' : ''
                                    }`}
                                    aria-labelledby='itinarary-header'
                                  >
                                    <div className='accordion-body'>
                                      <p className='text-success fw-bolder fs-6'>
                                        {t(
                                          'Provide a detailed day-by-day schedule of the tour. Include timings, activities, and any special events or stops.'
                                        )}
                                      </p>
                                      {primaryLanguage == 'English' && (
                                        <>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className='required fs-5 form-label'>
                                              {t('Itinarary (English)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={itinararyEN}
                                              onBlur={(newContent) => {
                                                setItinararyEN(newContent)
                                                removeError('itinararyEN')
                                              }}
                                              onChange={() => {
                                                if (error[0].itinararyEN) {
                                                  removeError('itinararyEN')
                                                }
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                            <div className='text-danger fw-bold'>
                                              {error[0].itinararyEN}
                                            </div>
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className=' fs-5 form-label'>
                                              {t('Itinarary (Russian)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={itinararyRU}
                                              onBlur={(newContent) => {
                                                setItinararyRU(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className=' fs-5 form-label'>
                                              {t('Itinarary (Uzbek)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={itinararyUZ}
                                              onBlur={(newContent) => {
                                                setItinararyUZ(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                        </>
                                      )}
                                      {primaryLanguage == 'Russian' && (
                                        <>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className='required fs-5 form-label'>
                                              {t('Itinarary (Russian)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={itinararyRU}
                                              onBlur={(newContent) => {
                                                setItinararyRU(newContent)
                                                removeError('itinararyRU')
                                              }}
                                              onChange={() => {
                                                if (error[0].itinararyRU) {
                                                  removeError('itinararyRU')
                                                }
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                            <div className='text-danger fw-bold'>
                                              {error[0].itinararyRU}
                                            </div>
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className=' fs-5 form-label'>
                                              {t('Itinarary (English)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={itinararyEN}
                                              onBlur={(newContent) => {
                                                setItinararyEN(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className=' fs-5 form-label'>
                                              {t('Itinarary (Uzbek)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={itinararyUZ}
                                              onBlur={(newContent) => {
                                                setItinararyUZ(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                        </>
                                      )}
                                      {primaryLanguage == 'Uzbek' && (
                                        <>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className='required fs-5 form-label'>
                                              {t('Itinarary (Uzbek)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={itinararyUZ}
                                              onBlur={(newContent) => {
                                                setItinararyUZ(newContent)
                                                removeError('itinararyUZ')
                                              }}
                                              onChange={() => {
                                                if (error[0].itinararyUZ) {
                                                  removeError('itinararyUZ')
                                                }
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                            <div className='text-danger fw-bold'>
                                              {error[0].itinararyRU}
                                            </div>
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className=' fs-5 form-label'>
                                              {t('Itinarary (Russian)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={itinararyRU}
                                              onBlur={(newContent) => {
                                                setItinararyRU(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className=' fs-5 form-label'>
                                              {t('Itinarary (English)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={itinararyEN}
                                              onBlur={(newContent) => {
                                                setItinararyEN(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                {/* what to expect */}
                                <div className='accordion-item'>
                                  <h2 className='accordion-header' id='whatToExpect-header'>
                                    <button
                                      className='accordion-button collapsed  text-dark fw-bold fs-3'
                                      type='button'
                                      data-bs-toggle='collapse'
                                      data-bs-target='#whatToExpect-collapse'
                                      aria-expanded='false'
                                      aria-controls='whatToExpect-collapse'
                                    >
                                      {t('What To Expect?')}
                                    </button>
                                  </h2>
                                  <div
                                    id='whatToExpect-collapse'
                                    className={`accordion-collapse collapse ${
                                      whatToexpectAccordionShow ? 'show' : ''
                                    }`}
                                    aria-labelledby='whatToExpect-header'
                                  >
                                    <div className='accordion-body'>
                                      <p className='text-success fw-bolder fs-6'>
                                        {t(
                                          'Give a brief overview of the tour experience. Describe the type of activities, the difficulty level, and any unique aspects travelers should anticipate.'
                                        )}
                                      </p>
                                      {primaryLanguage == 'English' && (
                                        <>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className='required fs-5 form-label'>
                                              {t('What To Expect? (English)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={whatToExpectEN}
                                              onBlur={(newContent) => {
                                                setWhatToExpectEN(newContent)
                                                removeError('whatToExpectEN')
                                              }}
                                              onChange={() => {
                                                if (error[0].whatToExpectEN) {
                                                  removeError('whatToExpectEN')
                                                }
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                            <div className='text-danger fw-bold'>
                                              {error[0].whatToExpectEN}
                                            </div>
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className=' fs-5 form-label'>
                                              {t('What To Expect? (Russian)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={whatToExpectRU}
                                              onBlur={(newContent) => {
                                                setWhatToExpectRU(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className=' fs-5 form-label'>
                                              {t('What To Expect? (Uzbek)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={whatToExpectUZ}
                                              onBlur={(newContent) => {
                                                setWhatToExpectUZ(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                        </>
                                      )}
                                      {primaryLanguage == 'Russian' && (
                                        <>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className='required fs-5 form-label'>
                                              {t('What To Expect? (Russian)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={whatToExpectRU}
                                              onBlur={(newContent) => {
                                                setWhatToExpectRU(newContent)
                                                removeError('whatToExpectRU')
                                              }}
                                              onChange={() => {
                                                if (error[0].whatToExpectRU) {
                                                  removeError('whatToExpectRU')
                                                }
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                            <div className='text-danger fw-bold'>
                                              {error[0].whatToExpectRU}
                                            </div>
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className=' fs-5 form-label'>
                                              {t('What To Expect? (English)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={whatToExpectEN}
                                              onBlur={(newContent) => {
                                                setWhatToExpectEN(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className=' fs-5 form-label'>
                                              {t('What To Expect? (Uzbek)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={whatToExpectUZ}
                                              onBlur={(newContent) => {
                                                setWhatToExpectUZ(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                        </>
                                      )}
                                      {primaryLanguage == 'Uzbek' && (
                                        <>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className='required fs-5 form-label'>
                                              {t('What To Expect? (Uzbek)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={whatToExpectUZ}
                                              onBlur={(newContent) => {
                                                setWhatToExpectUZ(newContent)
                                                removeError('whatToExpectUZ')
                                              }}
                                              onChange={() => {
                                                if (error[0].whatToExpectUZ) {
                                                  removeError('whatToExpectUZ')
                                                }
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                            <div className='text-danger fw-bold'>
                                              {error[0].whatToExpectUZ}
                                            </div>
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className=' fs-5 form-label'>
                                              {t('What To Expect? (Russian)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={whatToExpectRU}
                                              onBlur={(newContent) => {
                                                setWhatToExpectRU(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className=' fs-5 form-label'>
                                              {t('What To Expect? (English)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={whatToExpectEN}
                                              onBlur={(newContent) => {
                                                setWhatToExpectEN(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                {/* meeting point */}
                                <div className='accordion-item'>
                                  <h2 className='accordion-header' id='meetingPoint-header'>
                                    <button
                                      className='accordion-button collapsed  text-dark fw-bold fs-3'
                                      type='button'
                                      data-bs-toggle='collapse'
                                      data-bs-target='#meetingPoint-collapse'
                                      aria-expanded='false'
                                      aria-controls='meetingPoint-collapse'
                                    >
                                      {t('Meeting Point')}
                                    </button>
                                  </h2>
                                  <div
                                    id='meetingPoint-collapse'
                                    className={`accordion-collapse collapse ${
                                      meetingPointAccordionShow ? 'show' : ''
                                    }`}
                                    aria-labelledby='meetingPoint-header'
                                  >
                                    <div className='accordion-body'>
                                      {meetingPoints.map((meeting, index) => (
                                        <div className='row' key={index}>
                                          {primaryLanguage == 'English' && (
                                            <>
                                              <div className='col-lg-12'>
                                                <div className='row'>
                                                  <div className='col-lg my-3'>
                                                    <label className='required fs-4 form-label'>
                                                      {t('Meeting Point (English)')}
                                                    </label>
                                                    <input
                                                      type='text'
                                                      name='en_name'
                                                      placeholder={t('Meeting Point')}
                                                      className='form-control mb-2'
                                                      value={meeting.en_name}
                                                      onChange={(e) =>
                                                        handleMettingPointsChange(
                                                          index,
                                                          'en_name',
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                    {errors[index]?.en_name && (
                                                      <div className='text-danger fw-bold'>
                                                        {errors[index].en_name}
                                                      </div>
                                                    )}
                                                  </div>
                                                  <div className='col-lg my-3'>
                                                    <label className='fs-4 form-label'>
                                                      {t('Meeting Point (Russian)')}
                                                    </label>
                                                    <input
                                                      type='text'
                                                      name='ru_name'
                                                      placeholder={t('Meeting Point')}
                                                      className='form-control mb-2'
                                                      value={meeting.ru_name}
                                                      onChange={(e) =>
                                                        handleMettingPointsChange(
                                                          index,
                                                          'ru_name',
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                  <div className='col-lg my-3'>
                                                    <label className=' fs-4 form-label'>
                                                      {t('Meeting Point (Uzbek)')}
                                                    </label>
                                                    <input
                                                      type='text'
                                                      name='uz_name'
                                                      placeholder={t('Meeting Point')}
                                                      className='form-control mb-2'
                                                      value={meeting.uz_name}
                                                      onChange={(e) =>
                                                        handleMettingPointsChange(
                                                          index,
                                                          'uz_name',
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                  <div className='col-lg-2 d-flex justify-content-lg-start justify-content-end align-items-end my-3'>
                                                    {index !== 0 && (
                                                      <button
                                                        className='btn btn-danger mb-2 mx-1'
                                                        onClick={() =>
                                                          handleRemoveMettingPoints(index)
                                                        }
                                                      >
                                                        X
                                                      </button>
                                                    )}
                                                    <button
                                                      className='btn btn-success mb-2 mx-1'
                                                      onClick={handleAddMettingPoints}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </>
                                          )}
                                          {primaryLanguage == 'Russian' && (
                                            <>
                                              <div className='col-lg-12'>
                                                <div className='row'>
                                                  <div className='col-lg my-3'>
                                                    <label className='required fs-4 form-label'>
                                                      {t('Meeting Point (Russian)')}
                                                    </label>
                                                    <input
                                                      type='text'
                                                      name='ru_name'
                                                      placeholder={t('Meeting Point')}
                                                      className='form-control mb-2'
                                                      value={meeting.ru_name}
                                                      onChange={(e) =>
                                                        handleMettingPointsChange(
                                                          index,
                                                          'ru_name',
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                    {errors[index]?.ru_name && (
                                                      <div className='text-danger fw-bold'>
                                                        {errors[index].ru_name}
                                                      </div>
                                                    )}
                                                  </div>
                                                  <div className='col-lg my-3'>
                                                    <label className='fs-4 form-label'>
                                                      {t('Meeting Point (English)')}
                                                    </label>
                                                    <input
                                                      type='text'
                                                      name='en_name'
                                                      placeholder={t('Meeting Point')}
                                                      className='form-control mb-2'
                                                      value={meeting.en_name}
                                                      onChange={(e) =>
                                                        handleMettingPointsChange(
                                                          index,
                                                          'en_name',
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                  <div className='col-lg my-3'>
                                                    <label className='fs-4 form-label'>
                                                      {t('Meeting Point (Uzbek)')}
                                                    </label>
                                                    <input
                                                      type='text'
                                                      name='uz_name'
                                                      placeholder={t('Meeting Point')}
                                                      className='form-control mb-2'
                                                      value={meeting.uz_name}
                                                      onChange={(e) =>
                                                        handleMettingPointsChange(
                                                          index,
                                                          'uz_name',
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                  <div className='col-lg-2 d-flex justify-content-lg-start justify-content-end align-items-end my-3'>
                                                    {index !== 0 && (
                                                      <button
                                                        className='btn btn-danger mb-2 mx-1'
                                                        onClick={() =>
                                                          handleRemoveMettingPoints(index)
                                                        }
                                                      >
                                                        X
                                                      </button>
                                                    )}
                                                    <button
                                                      className='btn btn-success mb-2 mx-1'
                                                      onClick={handleAddMettingPoints}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </>
                                          )}
                                          {primaryLanguage == 'Uzbek' && (
                                            <>
                                              <div className='col-lg-12'>
                                                <div className='row'>
                                                  <div className='col-lg my-3'>
                                                    <label className='fs-4 form-label required'>
                                                      {t('Meeting Point (Uzbek)')}
                                                    </label>
                                                    <input
                                                      type='text'
                                                      name='uz_name'
                                                      placeholder={t('Meeting Point')}
                                                      className='form-control mb-2'
                                                      value={meeting.uz_name}
                                                      onChange={(e) =>
                                                        handleMettingPointsChange(
                                                          index,
                                                          'uz_name',
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                    {errors[index]?.uz_name && (
                                                      <div className='text-danger fw-bold'>
                                                        {errors[index].uz_name}
                                                      </div>
                                                    )}
                                                  </div>
                                                  <div className='col-lg my-3'>
                                                    <label className=' fs-4 form-label'>
                                                      {t('Meeting Point (Russian)')}
                                                    </label>
                                                    <input
                                                      type='text'
                                                      name='ru_name'
                                                      placeholder={t('Meeting Point')}
                                                      className='form-control mb-2'
                                                      value={meeting.ru_name}
                                                      onChange={(e) =>
                                                        handleMettingPointsChange(
                                                          index,
                                                          'ru_name',
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                  <div className='col-lg my-3'>
                                                    <label className='fs-4 form-label'>
                                                      {t('Meeting Point (English)')}
                                                    </label>
                                                    <input
                                                      type='text'
                                                      name='en_name'
                                                      placeholder={t('Meeting Point')}
                                                      className='form-control mb-2'
                                                      value={meeting.en_name}
                                                      onChange={(e) =>
                                                        handleMettingPointsChange(
                                                          index,
                                                          'en_name',
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                  <div className='col-lg-2 d-flex justify-content-lg-start justify-content-end align-items-end my-3'>
                                                    {index !== 0 && (
                                                      <button
                                                        className='btn btn-danger mb-2 mx-1'
                                                        onClick={() =>
                                                          handleRemoveMettingPoints(index)
                                                        }
                                                      >
                                                        X
                                                      </button>
                                                    )}
                                                    <button
                                                      className='btn btn-success mb-2 mx-1'
                                                      onClick={handleAddMettingPoints}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      ))}
                                      <p className='text-success fw-bolder fs-6'>
                                        {t(
                                          'Clearly state the exact location where participants should gather. Include any landmarks or detailed directions to help them find it easily.'
                                        )}
                                      </p>
                                      {primaryLanguage == 'English' && (
                                        <>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className='required fs-5 form-label'>
                                              {t('Meeting Point (English)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={meetingPointEN}
                                              onBlur={(newContent) => {
                                                setMeetingPointEN(newContent)
                                                removeError('meetingPointEN')
                                              }}
                                              onChange={() => {
                                                if (error[0].meetingPointEN) {
                                                  removeError('meetingPointEN')
                                                }
                                              }}
                                            />
                                            <div className='text-danger fw-bold'>
                                              {error[0].meetingPointEN}
                                            </div>
                                            {/* <!--end::Input--> */}
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className=' fs-5 form-label'>
                                              {t('Meeting Point (Russian)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={meetingPointRU}
                                              onBlur={(newContent) => {
                                                setMeetingPointRU(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className=' fs-5 form-label'>
                                              {t('Meeting Point (Uzbek)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={meetingPointUZ}
                                              onBlur={(newContent) => {
                                                setMeetingPointUZ(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                        </>
                                      )}
                                      {primaryLanguage == 'Russian' && (
                                        <>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className='required fs-5 form-label'>
                                              {t('Meeting Point (Russian)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={meetingPointRU}
                                              onBlur={(newContent) => {
                                                setMeetingPointRU(newContent)
                                                removeError('meetingPointRU')
                                              }}
                                              onChange={() => {
                                                if (error[0].meetingPointRU) {
                                                  removeError('meetingPointRU')
                                                }
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                            <div className='text-danger fw-bold'>
                                              {error[0].meetingPointRU}
                                            </div>
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className=' fs-5 form-label'>
                                              {t('Meeting Point (English)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={meetingPointEN}
                                              onBlur={(newContent) => {
                                                setMeetingPointEN(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className=' fs-5 form-label'>
                                              {t('Meeting Point (Uzbek)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={meetingPointUZ}
                                              onBlur={(newContent) => {
                                                setMeetingPointUZ(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                        </>
                                      )}
                                      {primaryLanguage == 'Uzbek' && (
                                        <>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className='required fs-5 form-label'>
                                              {t('Meeting Point (Uzbek)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={meetingPointUZ}
                                              onBlur={(newContent) => {
                                                setMeetingPointUZ(newContent)
                                                removeError('meetingPointUZ')
                                              }}
                                              onChange={() => {
                                                if (error[0].meetingPointUZ) {
                                                  removeError('meetingPointUZ')
                                                }
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                            <div className='text-danger fw-bold'>
                                              {error[0].meetingPointUZ}
                                            </div>
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className=' fs-5 form-label'>
                                              {t('Meeting Point (Russian)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={meetingPointRU}
                                              onBlur={(newContent) => {
                                                setMeetingPointRU(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className=' fs-5 form-label'>
                                              {t('Meeting Point (English)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={meetingPointEN}
                                              onBlur={(newContent) => {
                                                setMeetingPointEN(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                {/* activity essential */}
                                <div className='accordion-item'>
                                  <h2 className='accordion-header' id='activity-Essential-header'>
                                    <button
                                      className='accordion-button collapsed  text-dark fw-bold fs-3'
                                      type='button'
                                      data-bs-toggle='collapse'
                                      data-bs-target='#activity-Essential-collapse'
                                      aria-expanded='false'
                                      aria-controls='activity-Essential-collapse'
                                    >
                                      {t('Activity Essential')}
                                    </button>
                                  </h2>
                                  <div
                                    id='activity-Essential-collapse'
                                    className={`accordion-collapse collapse ${
                                      activityEssentialAccordionShow ? 'show' : ''
                                    }`}
                                    aria-labelledby='activity-Essential-header'
                                  >
                                    <div className='accordion-body'>
                                      <p className='text-success fw-bolder fs-6'>
                                        {t(
                                          'List items participants should prepare or bring with them. This might include clothing, equipment, documents, or anything else necessary for the tour.'
                                        )}
                                      </p>
                                      {primaryLanguage == 'English' && (
                                        <>
                                          {/* activity essetial */}
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className='required fs-5 form-label'>
                                              {t('Activity Essential (English)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={activityEssentialEN}
                                              onBlur={(newContent) => {
                                                setActivityEssentialEN(newContent)
                                                removeError('activityEssentialEN')
                                              }}
                                              onChange={() => {
                                                if (error[0].activityEssentialEN) {
                                                  removeError('activityEssentialEN')
                                                }
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                            <div className='text-danger fw-bold'>
                                              {error[0].activityEssentialEN}
                                            </div>
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className=' fs-5 form-label'>
                                              {t('Activity Essential (Russian)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={activityEssentialRU}
                                              onBlur={(newContent) => {
                                                setActivityEssentialRU(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className=' fs-5 form-label'>
                                              {t('Activity Essential (Uzbek)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={activityEssentialUZ}
                                              onBlur={(newContent) => {
                                                setActivityEssentialUZ(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                        </>
                                      )}
                                      {primaryLanguage == 'Russian' && (
                                        <>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className='required fs-5 form-label'>
                                              {t('Activity Essential (Russian)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={activityEssentialRU}
                                              onBlur={(newContent) => {
                                                setActivityEssentialRU(newContent)
                                                removeError('activityEssentialRU')
                                              }}
                                              onChange={() => {
                                                if (error[0].activityEssentialRU) {
                                                  removeError('activityEssentialRU')
                                                }
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                            <div className='text-danger fw-bold'>
                                              {error[0].activityEssentialRU}
                                            </div>
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className=' fs-5 form-label'>
                                              {t('Activity Essential (English)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={activityEssentialEN}
                                              onBlur={(newContent) => {
                                                setActivityEssentialEN(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className=' fs-5 form-label'>
                                              {t('Activity Essential (Uzbek)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={activityEssentialUZ}
                                              onBlur={(newContent) => {
                                                setActivityEssentialUZ(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                        </>
                                      )}
                                      {primaryLanguage == 'Uzbek' && (
                                        <>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className='required fs-5 form-label'>
                                              {t('Activity Essential (Uzbek)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={activityEssentialUZ}
                                              onBlur={(newContent) => {
                                                setActivityEssentialUZ(newContent)
                                                removeError('activityEssentialUZ')
                                              }}
                                              onChange={() => {
                                                if (error[0].activityEssentialUZ) {
                                                  removeError('activityEssentialUZ')
                                                }
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                            <div className='text-danger fw-bold'>
                                              {error[0].activityEssentialUZ}
                                            </div>
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className=' fs-5 form-label'>
                                              {t('Activity Essential (Russian)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={activityEssentialRU}
                                              onBlur={(newContent) => {
                                                setActivityEssentialRU(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                          <div className='col-lg-12 my-3'>
                                            {/* <!--begin::Label--> */}
                                            <label className=' fs-5 form-label'>
                                              {t('Activity Essential (English)')}
                                            </label>
                                            {/* <!--end::Label--> */}
                                            {/* <!--begin::Input--> */}
                                            <JoditEditor
                                              ref={editorRef}
                                              config={config}
                                              value={activityEssentialEN}
                                              onBlur={(newContent) => {
                                                setActivityEssentialEN(newContent)
                                              }}
                                            />
                                            {/* <!--end::Input--> */}
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className='row mt-5'>
                              <div className='col-lg-12'>
                                <div className='d-flex flex-wrap justify-content-end pb-lg-0'>
                                  <button
                                    type='button'
                                    className='btn btn-light-primary me-4'
                                    onClick={() => setTab('BasicInfo')}
                                  >
                                    {t('Back')}
                                  </button>
                                  <button
                                    type='button'
                                    disabled={disable}
                                    className='btn btn-primary me-4'
                                    onClick={nextToFacilityAndServices}
                                  >
                                    <span className='indicator-label'>{t('Next')}</span>
                                    {loading && (
                                      <span
                                        className='spinner-border spinner-border-sm mx-2'
                                        role='status'
                                        aria-hidden='true'
                                      ></span>
                                    )}
                                  </button>{' '}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='tab-content'>
                          <div
                            className={clsx('tab-pane', {active: tab === 'FacilityAndServices'})}
                          >
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label required'>{t('Services')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <Select
                                  name='serviceList[]'
                                  id='serviceList'
                                  placeholder={t('Select Service')}
                                  isSearchable={true}
                                  isMulti
                                  options={serviceList}
                                  value={serviceSelectedOptions}
                                  onChange={(e: any) => {
                                    setServiceSelectedOptions(e)
                                    removeError('service')
                                  }}
                                />
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>{error[0].service}</div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                <label className='fs-4 form-label required'>
                                  {t('Service Language')}
                                </label>
                                <Select
                                  name='serviceLanguage[]'
                                  id='serviceLanguage'
                                  placeholder={t('Select Service Language')}
                                  isSearchable={true}
                                  isMulti
                                  options={serviceLanguageList}
                                  value={serviceLanguageSelectedOptions}
                                  onChange={(e: any) => {
                                    setServiceLanguageSelectedOptions(e)
                                    removeError('serviceLanguage')
                                  }}
                                />
                                <div className='text-danger fw-bold'>
                                  {error[0].serviceLanguage}
                                </div>
                              </div>
                            </div>
                            <div className='row'>
                              <div className='col-lg-12 mt-3'>
                                <label className='fs-3 form-label fw-bold'>
                                  {t('What’s Included')}
                                </label>
                              </div>
                            </div>
                            <div className='row'>
                              <div className='col-lg-6 my-3'>
                                <label className='required fs-4 form-label'>
                                  {t('Is Included')}
                                </label>
                                <Select
                                  name='isIncluded[]'
                                  id='isIncluded'
                                  placeholder={t('Select Whats Included')}
                                  isSearchable={true}
                                  isMulti
                                  options={getFilteredOptions(whatsNotIncludedSelectedOptions)}
                                  value={whatsIncludedSelectedOptions}
                                  onChange={(e: any) => {
                                    handleIncludedChange(e)
                                    removeError('whatsIncluded')
                                  }}
                                />
                                <div className='text-danger fw-bold'>{error[0].whatsIncluded}</div>
                              </div>
                              <div className='col-lg-6 my-3'>
                                <label className='fs-4 form-label'>{t('Is Not Included')}</label>
                                <Select
                                  name='isNotIncluded[]'
                                  id='isNotIncluded'
                                  placeholder={t('Select Whats Not Included')}
                                  isSearchable={true}
                                  isMulti
                                  options={getFilteredOptions(whatsIncludedSelectedOptions)}
                                  value={whatsNotIncludedSelectedOptions}
                                  onChange={(e: any) => {
                                    handleNotIncludedChange(e)
                                  }}
                                />
                              </div>
                            </div>
                            <div className='row'>
                              <div className='col-lg-12'>
                                <div className='d-flex flex-wrap justify-content-end pb-lg-0'>
                                  <button
                                    type='button'
                                    className='btn btn-light-primary me-4'
                                    onClick={() => setTab('TourDetails')}
                                  >
                                    {t('Back')}
                                  </button>
                                  <button
                                    type='button'
                                    disabled={disable}
                                    className='btn btn-primary me-4'
                                    onClick={nextToPricingAndAvailability}
                                  >
                                    <span className='indicator-label'>{t('Next')}</span>
                                    {loading && (
                                      <span
                                        className='spinner-border spinner-border-sm mx-2'
                                        role='status'
                                        aria-hidden='true'
                                      ></span>
                                    )}
                                  </button>{' '}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='tab-content'>
                          <div
                            className={clsx('tab-pane', {active: tab === 'PricingAndAvailability'})}
                          >
                            <div className='card-header card-header-stretch overflow-auto'>
                              <ul
                                className='nav nav-stretch nav-line-tabs fw-semibold border-transparent flex-nowrap'
                                role='tablist'
                              >
                                <li className='nav-item'>
                                  <a
                                    className={clsx(`nav-link cursor-pointer`, {
                                      active: priceTab === 'RegularPrice',
                                    })}
                                    onClick={() => setPriceTab('RegularPrice')}
                                    role='tab'
                                  >
                                    {t('Regular Price')}
                                  </a>
                                </li>
                                <li className='nav-item'>
                                  <a
                                    className={clsx(`nav-link cursor-pointer`, {
                                      active: priceTab === 'SpecialPrice',
                                    })}
                                    onClick={() => setPriceTab('SpecialPrice')}
                                    role='tab'
                                  >
                                    {t('Special Price')}
                                  </a>
                                </li>
                                <li className='nav-item'>
                                  <a
                                    className={clsx(`nav-link cursor-pointer`, {
                                      active: priceTab === 'Availability',
                                    })}
                                    onClick={() => setPriceTab('Availability')}
                                    role='tab'
                                  >
                                    {t('Availability')}
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <div className='tab-content pt-3'>
                              <div
                                className={clsx('tab-pane', {active: priceTab === 'RegularPrice'})}
                              >
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    <PriceInput
                                      labelClass='required fs-5 form-label'
                                      label={t('Tour Price')}
                                      inputClass='form-control border-right-0'
                                      placeholder={t('Tour Price')}
                                      value={baseCharge}
                                      onChange={(e: any) => {
                                        setBaseCharge(e)
                                        removeError('baseCharge')
                                      }}
                                    />
                                    <div className='text-danger fw-bold'>{error[0].baseCharge}</div>
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='required fs-4 form-label'>
                                      {t('Tour Package Duration Day')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='durationDay'
                                      className='form-control mb-2'
                                      placeholder={t('Duration Day')}
                                      value={durationDay}
                                      onChange={(e) => {
                                        setDurationDay(e.target.value)
                                        removeError('durationDay')
                                      }}
                                    />
                                    {/* <!--end::Input--> */}
                                    <div className='text-danger fw-bold'>
                                      {error[0].durationDay}
                                    </div>
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='required fs-4 form-label'>
                                      {t('Tour Package Duration Hour')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='durationHour'
                                      className='form-control mb-2'
                                      placeholder={t('Duration Hour')}
                                      value={durationHour}
                                      onChange={(e) => {
                                        setDurationHour(e.target.value)
                                        removeError('durationHour')
                                      }}
                                    />
                                    {/* <!--end::Input--> */}
                                    <div className='text-danger fw-bold'>
                                      {error[0].durationHour}
                                    </div>
                                  </div>
                                </div>
                                 <div className='row'>
                                  <div className='col-lg-12'>
                                    <div className='d-flex flex-wrap justify-content-end pb-lg-0'>
                                      <button
                                        type='button'
                                        disabled={disable}
                                        className='btn btn-primary me-4'
                                        onClick={() => setPriceTab("SpecialPrice")}
                                      >
                                        <span className='indicator-label'>{t('Next')}</span>
                                        {loading && (
                                          <span
                                            className='spinner-border spinner-border-sm mx-2'
                                            role='status'
                                            aria-hidden='true'
                                          ></span>
                                        )}
                                      </button>{' '}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className='tab-content pt-3'>
                              <div
                                className={clsx('tab-pane', {active: priceTab === 'SpecialPrice'})}
                              >
                                <div className='col-lg-12 d-flex bg-light-warning p-3 border rounded border-warning'>
                                  <i className='fas fa-info-circle text-success fs-5 mt-1'></i>
                                  <label className='fs-7 text-gray-600 form-label ms-2'>
                                    {' '}
                                    {t(
                                      'Fill out this section only if you want to set “Special Prices” for your services. Otherwise, simply skip it. Special Prices are typically offered to customers during holidays and special days at your discretion.'
                                    )}
                                  </label>
                                </div>
                                <div className='row mt-5'>
                                  <div className='col-lg-12'>
                                    <label className='fs-4 fw-bolder form-label'>
                                      {t('Date Range')}
                                    </label>
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-5 required form-label'>{t('From')}</label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <Flatpickr
                                      value={fromDate}
                                      onChange={([date]) => {
                                        setFromDate(date.toISOString())
                                        clearValidationError('fromDate')
                                      }}
                                      options={{
                                        enableTime: true,
                                        dateFormat: 'Y-m-d H:i',
                                      }}
                                      className='form-control mb-2'
                                      placeholder={t('Date')}
                                    />
                                    <div className='text-danger fw-bold'>
                                      {validationErrors[0].fromDate}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-5 required form-label'>{t('To')}</label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <Flatpickr
                                      value={toDate}
                                      onChange={([date]) => {
                                        setToDate(date.toISOString())
                                        clearValidationError('toDate')
                                      }}
                                      options={{
                                        enableTime: true,
                                        dateFormat: 'Y-m-d H:i',
                                      }}
                                      className='form-control mb-2'
                                      placeholder={t('Date')}
                                    />
                                    <div className='text-danger fw-bold'>
                                      {validationErrors[0].toDate}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                {primaryLanguage == 'English' && (
                                  <div className='row'>
                                    <div className='col-lg-4 my-3'>
                                      {/* <!--begin::Label--> */}
                                      <label className='required fs-5 form-label'>
                                        {t('Title (English)')}
                                      </label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input
                                        type='text'
                                        name='en_title'
                                        className='form-control mb-2'
                                        placeholder={t('Title')}
                                        value={en_title}
                                        onChange={(e) => {
                                          setEn_title(e.target.value)
                                          clearValidationError('en_title')
                                        }}
                                      />
                                      <div className='text-danger fw-bold'>
                                        {validationErrors[0].en_title}
                                      </div>
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className='col-lg-4 my-3'>
                                      {/* <!--begin::Label--> */}
                                      <label className='fs-5 form-label'>
                                        {t('Title (Russian)')}
                                      </label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input
                                        type='text'
                                        name='ru_title'
                                        className='form-control mb-2'
                                        placeholder={t('Title')}
                                        value={ru_title}
                                        onChange={(e) => {
                                          setRu_title(e.target.value)
                                        }}
                                      />
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className='col-lg-4 my-3'>
                                      {/* <!--begin::Label--> */}
                                      <label className='fs-5 form-label'>
                                        {t('Title (Uzbek)')}
                                      </label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input
                                        type='text'
                                        name='uz_title'
                                        className='form-control mb-2'
                                        placeholder={t('Title')}
                                        value={uz_title}
                                        onChange={(e) => {
                                          setUz_title(e.target.value)
                                        }}
                                      />
                                      {/* <!--end::Input--> */}
                                    </div>
                                  </div>
                                )}
                                {primaryLanguage == 'Russian' && (
                                  <div className='row'>
                                    <div className='col-lg-4 my-3'>
                                      {/* <!--begin::Label--> */}
                                      <label className='required fs-5 form-label'>
                                        {t('Title (Russian)')}
                                      </label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input
                                        type='text'
                                        name='ru_title'
                                        className='form-control mb-2'
                                        placeholder={t('Title')}
                                        value={ru_title}
                                        onChange={(e) => {
                                          setRu_title(e.target.value)
                                          clearValidationError('ru_title')
                                        }}
                                      />
                                      <div className='text-danger fw-bold'>
                                        {validationErrors[0].ru_title}
                                      </div>
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className='col-lg-4 my-3'>
                                      {/* <!--begin::Label--> */}
                                      <label className='fs-5 form-label'>
                                        {t('Title (English)')}
                                      </label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input
                                        type='text'
                                        name='en_title'
                                        className='form-control mb-2'
                                        placeholder={t('Title')}
                                        value={en_title}
                                        onChange={(e) => {
                                          setEn_title(e.target.value)
                                        }}
                                      />
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className='col-lg-4 my-3'>
                                      {/* <!--begin::Label--> */}
                                      <label className='fs-5 form-label'>
                                        {t('Title (Uzbek)')}
                                      </label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input
                                        type='text'
                                        name='uz_title'
                                        className='form-control mb-2'
                                        placeholder={t('Title')}
                                        value={uz_title}
                                        onChange={(e) => {
                                          setUz_title(e.target.value)
                                        }}
                                      />
                                      {/* <!--end::Input--> */}
                                    </div>
                                  </div>
                                )}
                                {primaryLanguage == 'Uzbek' && (
                                  <div className='row'>
                                    <div className='col-lg-4 my-3'>
                                      {/* <!--begin::Label--> */}
                                      <label className='required fs-5 form-label'>
                                        {t('Title (Uzbek)')}
                                      </label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input
                                        type='text'
                                        name='uz_title'
                                        className='form-control mb-2'
                                        placeholder={t('Title')}
                                        value={uz_title}
                                        onChange={(e) => {
                                          setUz_title(e.target.value)
                                          clearValidationError('uz_title')
                                        }}
                                      />
                                      <div className='text-danger fw-bold'>
                                        {validationErrors[0].uz_title}
                                      </div>
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className='col-lg-4 my-3'>
                                      {/* <!--begin::Label--> */}
                                      <label className='fs-5 form-label'>
                                        {t('Title (Russian)')}
                                      </label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input
                                        type='text'
                                        name='ru_title'
                                        className='form-control mb-2'
                                        placeholder={t('Title')}
                                        value={ru_title}
                                        onChange={(e) => {
                                          setRu_title(e.target.value)
                                        }}
                                      />
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className='col-lg-4 my-3'>
                                      {/* <!--begin::Label--> */}
                                      <label className='fs-5 form-label'>
                                        {t('Title (English)')}
                                      </label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input
                                        type='text'
                                        name='en_title'
                                        className='form-control mb-2'
                                        placeholder={t('Title')}
                                        value={en_title}
                                        onChange={(e) => {
                                          setEn_title(e.target.value)
                                        }}
                                      />
                                      {/* <!--end::Input--> */}
                                    </div>
                                  </div>
                                )}
                                <div className='row'>
                                  <div className='col-lg-3 mb-3'>
                                    <PriceInput
                                      labelClass='fs-6 form-label required'
                                      label={t('Monday')}
                                      inputClass='form-control mb-0 border-right-0'
                                      placeholder={t('Price')}
                                      value={mondayPrice}
                                      onChange={(e: any) => {
                                        setMondayPrice(e)
                                        clearValidationError('mondayPrice')
                                      }}
                                    />
                                    <div className='text-danger fw-bold'>
                                      {validationErrors[0].mondayPrice}
                                    </div>
                                  </div>
                                  <div className='col-lg-3 mb-3'>
                                    <PriceInput
                                      labelClass='fs-6 form-label required'
                                      label={t('Tuesday')}
                                      inputClass='form-control mb-0 border-right-0'
                                      placeholder={t('Price')}
                                      value={tuesdayPrice}
                                      onChange={(e: any) => {
                                        setTuesdayPrice(e)
                                        clearValidationError('tuesdayPrice')
                                      }}
                                    />
                                    <div className='text-danger fw-bold'>
                                      {validationErrors[0].tuesdayPrice}
                                    </div>
                                  </div>
                                  <div className='col-lg-3 mb-3'>
                                    <PriceInput
                                      labelClass='fs-6 form-label required'
                                      label={t('Wednesday')}
                                      inputClass='form-control mb-0 border-right-0'
                                      placeholder={t('Price')}
                                      value={wednesdayPrice}
                                      onChange={(e: any) => {
                                        setWednesdayPrice(e)
                                        clearValidationError('wednesdayPrice')
                                      }}
                                    />
                                    <div className='text-danger fw-bold'>
                                      {validationErrors[0].wednesdayPrice}
                                    </div>
                                  </div>
                                  <div className='col-lg-3 mb-3'>
                                    <PriceInput
                                      labelClass='fs-6 form-label required'
                                      label={t('Thursday')}
                                      inputClass='form-control mb-0 border-right-0'
                                      placeholder={t('Price')}
                                      value={thursdayPrice}
                                      onChange={(e: any) => {
                                        setThursdayPrice(e)
                                        clearValidationError('thursdayPrice')
                                      }}
                                    />
                                    <div className='text-danger fw-bold'>
                                      {validationErrors[0].thursdayPrice}
                                    </div>
                                  </div>
                                  <div className='col-lg-3 mb-3'>
                                    <PriceInput
                                      labelClass='fs-6 form-label required'
                                      label={t('Friday')}
                                      inputClass='form-control mb-0 border-right-0'
                                      placeholder={t('Price')}
                                      value={fridayPrice}
                                      onChange={(e: any) => {
                                        setFridayPrice(e)
                                        clearValidationError('fridayPrice')
                                      }}
                                    />
                                    <div className='text-danger fw-bold'>
                                      {validationErrors[0].fridayPrice}
                                    </div>
                                  </div>
                                  <div className='col-lg-3 mb-3'>
                                    <PriceInput
                                      labelClass='fs-6 form-label required'
                                      label={t('Saturday')}
                                      inputClass='form-control mb-0 border-right-0'
                                      placeholder={t('Price')}
                                      value={saturdayPrice}
                                      onChange={(e: any) => {
                                        setSaturdayPrice(e)
                                        clearValidationError('saturdayPrice')
                                      }}
                                    />
                                    <div className='text-danger fw-bold'>
                                      {validationErrors[0].saturdayPrice}
                                    </div>
                                  </div>
                                  <div className='col-lg-3 mb-3'>
                                    <PriceInput
                                      labelClass='fs-6 form-label required'
                                      label={t('Sunday')}
                                      inputClass='form-control mb-0 border-right-0'
                                      placeholder={t('Price')}
                                      value={sundayPrice}
                                      onChange={(e: any) => {
                                        setSundayPrice(e)
                                        clearValidationError('sundayPrice')
                                      }}
                                    />
                                    <div className='text-danger fw-bold'>
                                      {validationErrors[0].sundayPrice}
                                    </div>
                                  </div>
                                  <div className='col-lg-3 d-flex justify-content-center align-items-end'>
                                    <button className='btn btn-primary mb-3' onClick={handleSave}>
                                      {editIndex > -1 ? 'Update' : 'Save'}
                                    </button>
                                  </div>
                                </div>
                                <div className='card'>
                                  {/* begin::Body */}
                                  <div className='card-body pt-5 p-0'>
                                    {/* begin::Table container */}
                                    <div className='table-responsive'>
                                      {/* begin::Table */}
                                      <table className='table align-middle gs-0 gy-4'>
                                        {/* begin::Table head */}
                                        <thead>
                                          <tr className='fw-bold text-muted bg-light'>
                                            <th className='ps-4 min-w-325px rounded-start'>
                                              {t('Date Range')}
                                            </th>
                                            <th className='min-w-150px'>{t('Title')}</th>
                                            <th className='min-w-150px'>{t('Mon')}</th>
                                            <th className='min-w-150px'>{t('Tue')}</th>
                                            <th className='min-w-150px'>{t('Wed')}</th>
                                            <th className='min-w-150px'>{t('Thu')}</th>
                                            <th className='min-w-150px'>{t('Fri')}</th>
                                            <th className='min-w-150px'>{t('Sat')}</th>
                                            <th className='min-w-150px'>{t('Sun')}</th>
                                            <th className='min-w-200px rounded-end'>
                                              {t('Action')}
                                            </th>
                                          </tr>
                                        </thead>
                                        {/* end::Table head */}
                                        {/* begin::Table body */}
                                        <tbody>
                                          {specialPrice.map((item: any, index: any) => {
                                            return (
                                              <tr key={index}>
                                                <td>
                                                  <div className='d-flex align-items-center'>
                                                    <div className='d-flex justify-content-start flex-column'>
                                                      <h6 className='fw-bold mb-1 fs-7'>
                                                        {formatDate(item.fromDate)} to{' '}
                                                        {formatDate(item.toDate)}
                                                      </h6>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td>
                                                  <h6 className='fw-bold d-block mb-1 fs-7'>
                                                    {getTranslatedValue(
                                                      lang,
                                                      item,
                                                      '_title',
                                                      primaryLanguage
                                                    )}
                                                  </h6>
                                                </td>
                                                <td>
                                                  <h6 className='fw-bold d-block mb-1 fs-7'>
                                                    {item.mondayPrice}
                                                  </h6>
                                                </td>
                                                <td>
                                                  <h6 className='fw-bold d-block mb-1 fs-7'>
                                                    {item.tuesdayPrice}
                                                  </h6>
                                                </td>
                                                <td>
                                                  <h6 className='fw-bold d-block mb-1 fs-7'>
                                                    {item.wednesdayPrice}
                                                  </h6>
                                                </td>
                                                <td>
                                                  <h6 className='fw-bold d-block mb-1 fs-7'>
                                                    {item.thursdayPrice}
                                                  </h6>
                                                </td>
                                                <td>
                                                  <h6 className='fw-bold d-block mb-1 fs-7'>
                                                    {item.fridayPrice}
                                                  </h6>
                                                </td>
                                                <td>
                                                  <h6 className='fw-bold d-block mb-1 fs-7'>
                                                    {item.saturdayPrice}
                                                  </h6>
                                                </td>
                                                <td>
                                                  <h6 className='fw-bold d-block mb-1 fs-7'>
                                                    {item.sundayPrice}
                                                  </h6>
                                                </td>
                                                <td>
                                                  <button
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                    onClick={() => handleEdit(index)}
                                                  >
                                                    <KTIcon iconName='pencil' className='fs-3' />
                                                  </button>
                                                  <button
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                                    onClick={() => handleRemove(index)}
                                                  >
                                                    <KTIcon iconName='trash' className='fs-3' />
                                                  </button>
                                                </td>
                                              </tr>
                                            )
                                          })}
                                        </tbody>
                                        {/* end::Table body */}
                                      </table>
                                      {specialPrice.length == 0 && (
                                        <div className='row'>
                                          <div className='col-lg-12 text-center'>
                                            <label className='fs-6 text-gray-500 my-5 text-center'>
                                              {t('No Records Found.')}
                                            </label>
                                          </div>
                                        </div>
                                      )}
                                      {/* end::Table */}
                                    </div>
                                    {/* end::Table container */}
                                  </div>
                                   <div className='row'>
                                  <div className='col-lg-12'>
                                    <div className='d-flex flex-wrap justify-content-end pb-lg-0'>
                                      <button
                                        type='button'
                                        className='btn btn-light-primary me-4'
                                        onClick={() => setPriceTab('RegularPrice')}
                                      >
                                        {t('Back')}
                                      </button>
                                      <button
                                        type='button'
                                        disabled={disable}
                                        className='btn btn-primary me-4'
                                        onClick={() => setPriceTab("Availability")}
                                      >
                                        <span className='indicator-label'>{t('Next')}</span>
                                        {loading && (
                                          <span
                                            className='spinner-border spinner-border-sm mx-2'
                                            role='status'
                                            aria-hidden='true'
                                          ></span>
                                        )}
                                      </button>{' '}
                                    </div>
                                  </div>
                                </div>
                                  {/* begin::Body */}
                                </div>
                              </div>
                            </div>
                            <div className='tab-content pt-3'>
                              <div
                                className={clsx('tab-pane', {active: priceTab === 'Availability'})}
                              >
                                <div className='row'>
                                  <div className='col-lg-12'>
                                    <label className='fs-3 form-label'>{t('Availability')}</label>
                                  </div>
                                  <div className='col-lg-12 my-2'>
                                    <label className='form-check form-check-inline form-check-solid me-5'>
                                      <input
                                        className='form-check-input me-3'
                                        type='checkbox'
                                        name='isYear'
                                        value='true'
                                        checked={isYear}
                                        onChange={(e: any) => {
                                          handleIsYear(e)
                                          removeError('isYear')
                                        }}
                                      />
                                      <span className='form-check-label d-flex flex-column align-items-start'>
                                        <span className='fw-bold ps-2 fs-6 text-dark'>
                                          {t('All year around')}
                                        </span>
                                      </span>
                                    </label>
                                  </div>
                                  {!isYear && (
                                    <>
                                      <div className='col-lg-4 my-3'>
                                        {/* <!--begin::Label--> */}
                                        <label className='required fs-4 form-label'>
                                          {t('From Date')}
                                        </label>
                                        {/* <!--end::Label--> */}
                                        {/* <!--begin::Input--> */}
                                        <input
                                          type='date'
                                          name='fromAvailableDate'
                                          className='form-control mb-2'
                                          value={fromAvailableDate}
                                          onChange={(e) => {
                                            setFromAvailableDate(e.target.value)
                                            removeError('fromAvailableDate')
                                          }}
                                        />
                                        {/* <!--end::Input--> */}
                                        <div className='text-danger fw-bold'>
                                          {error[0].fromAvailableDate}
                                        </div>
                                      </div>
                                      <div className='col-lg-4 my-3'>
                                        {/* <!--begin::Label--> */}
                                        <label className='required fs-4 form-label'>
                                          {t('To Date')}
                                        </label>
                                        {/* <!--end::Label--> */}
                                        {/* <!--begin::Input--> */}
                                        <input
                                          type='date'
                                          name='toAvailableDate'
                                          className='form-control mb-2'
                                          value={toAvailableDate}
                                          onChange={(e) => {
                                            setToAvailableDate(e.target.value)
                                            removeError('toAvailableDate')
                                          }}
                                        />
                                        {/* <!--end::Input--> */}
                                        <div className='text-danger fw-bold'>
                                          {error[0].toAvailableDate}
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </div>
                                <StepErrorAlert
                                  message={priceStepError}
                                  actionLabel={t('Go To Regular Price')}
                                  onAction={() => setPriceTab('RegularPrice')}
                                />
                                <div className='row'>
                                  <div className='col-lg-12'>
                                    <div className='d-flex flex-wrap justify-content-end pb-lg-0'>
                                      <button
                                        type='button'
                                        className='btn btn-light-primary me-4'
                                        onClick={() => setPriceTab("SpecialPrice")}
                                      >
                                        {t('Back')}
                                      </button>
                                      <button
                                        type='button'
                                        disabled={disable}
                                        className='btn btn-primary me-4'
                                        onClick={nextToTourPhotos}
                                      >
                                        <span className='indicator-label'>{t('Next')}</span>
                                        {loading && (
                                          <span
                                            className='spinner-border spinner-border-sm mx-2'
                                            role='status'
                                            aria-hidden='true'
                                          ></span>
                                        )}
                                      </button>{' '}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='tab-content'>
                          <div className={clsx('tab-pane', {active: tab === 'TourPhotos'})}>
                            <div className='row'>
                              <div className='col-lg-12'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-5 form-label'>{t('Upload images')}</label>
                                {/* <!--end::Label--> */}
                                <br />
                                <input
                                  ref={inputfileRef}
                                  style={{display: 'none'}}
                                  className='modaldocument'
                                  type='file'
                                  onChange={handleImageChange}
                                  accept='image/*'
                                  multiple
                                />
                                <div className='d-flex flex-wrap align-items-center gap-3'>
                                  <span
                                    className='btn btn-light text-primary cursor-pointer '
                                    onClick={handleTextClick}
                                  >
                                    {' '}
                                    {t('Attach Images')}
                                  </span>
                                  <ReorderButton reorder={reorder} />
                                </div>
                                <div className='text-danger fw-bold'>{error[0].inputImage}</div>
                                <UploadedImageGrid
                                  reorder={reorder}
                                  images={uploadedImage}
                                  onRemove={handleRemoveImage}
                                />
                                <NewImageGrid
                                  reorder={reorder}
                                  files={inputImage}
                                  onRemove={handleRemove1}
                                />
                              </div>
                            </div>
                            {/* <!--end::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-12'>
                                <div className='d-flex flex-wrap justify-content-end pb-lg-0'>
                                  <button
                                    type='button'
                                    className='btn btn-light-primary me-4'
                                    onClick={() => setTab('PricingAndAvailability')}
                                  >
                                    {t('Back')}
                                  </button>
                                  <button
                                    type='button'
                                    disabled={disable}
                                    className='btn btn-primary me-4'
                                    onClick={() => {
                                      if (editToursId !== '') {
                                        editTourDetailApi()
                                      } else {
                                        addTourDetailApi()
                                      }
                                    }}
                                  >
                                    <span className='indicator-label'>{t('Submit')}</span>
                                    {loading && (
                                      <span
                                        className='spinner-border spinner-border-sm mx-2'
                                        role='status'
                                        aria-hidden='true'
                                      ></span>
                                    )}
                                  </button>{' '}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <!--end::Controls--> */}
                    </div>
                    {/* <!--end::Dropzone--> */}
                  </div>
                  {/* <!--end::Input group--> */}
                </div>
                {/* <!--end::Modal body--> */}
              </div>
              {/* <!--end::Form--> */}
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export {ViewTours}
